import { resolveMediaUrl, resolveMediaCssUrl } from '../../../common/mediaUrl';
import React from 'react'
import { Render, FieldLabel, DropZone } from "@measured/puck";
import './styles/style.css';
import Svg from '../../../common/Svg';
import { Link } from 'react-router-dom';
import bannerImageLaptop from './images/banner-image.png'
import Logo from './images/logo.svg';
import BgImage from './images/bg-image.png';

import ReactEcharts from "echarts-for-react";
import DateField from "./DateField";
import Range from "./Range";
import CardIcon from './images/lower-cost.png'
import icon from './images/roi-download.png'
import LogoWhite from './images/logo-white.svg';
import LogoThankYou from './images/logo-thank-you.svg';
import icon2 from './images/icon.svg'

const ROI_NUMBER_LOCALE = "en-US";

function roiAmountLocaleOptions(n) {
    if (!Number.isFinite(n)) {
        return { minimumFractionDigits: 0, maximumFractionDigits: 2 };
    }
    const whole =
        Number.isInteger(n) || Math.abs(n - Math.round(n)) < 1e-9;
    return {
        minimumFractionDigits: 0,
        maximumFractionDigits: whole ? 0 : 2,
    };
}

/**
 * Add US-style digit grouping for £ / $ / € amounts in a string.
 * See ROIPage.js formatRoiCurrencyDescription (kept in sync).
 */
function formatRoiCurrencyDescription(text) {
    if (text == null || typeof text !== "string") return text;
    const s = text
        .replace(/&#36;|&#[xX]24;|&dollar;/gi, "")
        .trim();
    if (!s) return text;

    const symClass = "[\u00A3£$€]";
    const usGroupedBody = /^-?\d{1,3}(?:,\d{3})*(?:\.\d+)?$/;

    const whole = s.match(
        new RegExp(`^(${symClass})\\s*([-]?\\d{1,3}(?:,\\d{3})*(?:\\.\\d+)?|-?\\d+(?:\\.\\d+)?)$`)
    );
    if (whole) {
        const body = whole[2].replace(/,/g, "");
        const n = parseFloat(body);
        if (!Number.isFinite(n)) return text;
        if (whole[2].includes(",") && !usGroupedBody.test(whole[2].replace(/\s/g, "")))
            return text;
        const formatted = n.toLocaleString(ROI_NUMBER_LOCALE, roiAmountLocaleOptions(n));
        const sym = whole[1];
        if (sym === "$" || sym === "\u0024") return formatted;
        return sym + formatted;
    }

    return s.replace(
        new RegExp(`(${symClass})\\s*(\\d{4,})(\\.\\d+)?(?!\\d)`, "g"),
        (match, sym, intPart, dec) => {
            const numStr = intPart + (dec || "");
            const n = parseFloat(numStr);
            if (!Number.isFinite(n)) return match;
            const formatted = n.toLocaleString(ROI_NUMBER_LOCALE, roiAmountLocaleOptions(n));
            if (sym === "$" || sym === "\u0024") return formatted;
            return sym + formatted;
        }
    );
}

const LandingPageData = {
    "content": [
        {
            "type": "GradientSection",
            "props": {
                "Style": {
                    "Width": "container"
                },
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60",
                    "fullHeight": true
                },
                "id": "GradientSection-e467e1ed-c123-445b-991b-30e5739f91ab"
            }
        }
    ],
    "root": {},
    "zones": {
        "GradientSection-e467e1ed-c123-445b-991b-30e5739f91ab:section": [
            {
                "type": "Columns",
                "props": {
                    "distribution": "manual",
                    "vertical": "align-items-center",
                    "gap": 30,
                    "columns": [
                        {
                            "span": 6
                        },
                        {
                            "span": 6
                        }
                    ],
                    "id": "Columns-fe9a3a94-65b8-4eef-baae-c1c3f5eb27f9"
                }
            }
        ],
        "Columns-fe9a3a94-65b8-4eef-baae-c1c3f5eb27f9:column-0": [
            {
                "type": "Heading",
                "props": {
                    "Text": {
                        "title": "TCO Calculator",
                        "titleFont": "fs-64",
                        "fontWeight": "fw-700",
                        "tag": "h1",
                        "Color": "#fff",
                        "Align": "left"
                    },
                    "id": "Heading-e5e3e54a-8ae2-4d93-92a2-8e89b11d1677"
                }
            },
            {
                "type": "Spacing",
                "props": {
                    "Height": "30px",
                    "id": "Spacing-7d963511-e02b-4744-b01c-a96464dbd7d4"
                }
            },
            {
                "type": "Text",
                "props": {
                    "Text": {
                        "text": "<p>Explore your Vodafone plan options effortlessly with our Assessment Calculator tool. Simply input your usage details, preferences, and needs, and gain insights into the most suitable plans tailored to you. </p>\n<p>\nFrom data allowances to international calls, the Assessment Calculator empowers you to make informed decisions about your telecommunications services. Say goodbye to guesswork and hello to personalized solutions with Vodafone's user-friendly tool, ensuring you get the most out of your mobile experience.</p>",
                        "FontSize": "fs-24",
                        "FontWeight": "fw-400",
                        "Color": "#fff",
                        "Align": "left"
                    },
                    "id": "Text-69f6ecec-64cd-4b32-8a1e-88c8bb7f966b"
                }
            },
            {
                "type": "Spacing",
                "props": {
                    "Height": "50px",
                    "id": "Spacing-9d5509cd-10c6-432a-bda4-7b36e0409406"
                }
            },
            {
                "type": "Button",
                "props": {
                    "Button": {
                        "buttonText": "Button",
                        "buttonLink": "https://www.google.com",
                        "buttonStyle": "primary",
                        "buttonicon": "yes"
                    },
                    "id": "Button-77402265-85bc-42c0-8d93-a6c5397f84b6"
                }
            }
        ],
        "Columns-fe9a3a94-65b8-4eef-baae-c1c3f5eb27f9:column-1": [
            {
                "type": "Image",
                "props": {
                    "Image": "/static/media/banner-image.bb8102da0565fa0abb86.png",
                    "AspectRatio": "auto",
                    "id": "Image-2c8fbca3-65f6-417e-8f99-39b135dd53c7"
                }
            }
        ]
    }
}

const CardPageData = {
    "content": [
        {
            "type": "GradientSection",
            "props": {
                "Style": {
                    "Width": "container"
                },
                "Padding": {
                    "top": "pt-90",
                    "bottom": "pb-90",
                    "fullHeight": false
                },
                "id": "GradientSection-e8cc1fe6-2619-42af-90f9-d863a77426ad"
            }
        }
    ],
    "root": {},
    "zones": {
        "GradientSection-e8cc1fe6-2619-42af-90f9-d863a77426ad:section": [
            {
                "type": "RedCards",
                "props": {
                    "Settings": {
                        "Border": {
                            "BorderStyle": "solid",
                            "BorderWidth": "3",
                            "BorderRadius": 12,
                            "BorderColor": "#e60000"
                        },
                        "Card": {
                            "Padding": {
                                "top": 13,
                                "right": 13,
                                "bottom": 13,
                                "left": 13
                            },
                            "UniqueID": "Section_ID"
                        },
                        "Text": {
                            "TitleFont": "fs-38",
                            "TitleFontWeight": "fw-700",
                            "TitleColor": "#fff",
                            "DescriptionFont": "fs-20",
                            "DescriptionFontWeight": "fw-400",
                            "DescriptionColor": "#fff",
                            "Align": "center"
                        }
                    },
                    "Lists": [
                        {
                            "Title": "Microsoft 365",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        },
                        {
                            "Title": "Subheading one",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        },
                        {
                            "Title": "Subheading one",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        }
                    ],
                    "id": "RedCards-b6899bd3-2cc3-46a9-91fe-d89fc30faebc"
                }
            }
        ]
    }
}

const WhiteCardData = {
    "content": [
        {
            "type": "TransparentSection",
            "props": {
                "Style": {
                    "Background": "",
                    "BackgroundColor": "#fff",
                    "Width": "container"
                },
                "Padding": {
                    "top": "pt-90",
                    "bottom": "pb-90",
                    "fullHeight": false
                },
                "id": "TransparentSection-3ff5bb89-e8e6-423c-892c-f832fb61ef22"
            }
        }
    ],
    "root": {},
    "zones": {
        "TransparentSection-3ff5bb89-e8e6-423c-892c-f832fb61ef22:section": [
            {
                "type": "Heading",
                "props": {
                    "Text": {
                        "title": "Choose license",
                        "titleFont": "fs-56",
                        "fontWeight": "fw-700",
                        "tag": "h2",
                        "Color": "#000000",
                        "Align": "center"
                    },
                    "id": "Heading-997f1fd9-e34b-4ea4-ac30-645319ea9373"
                }
            },
            {
                "type": "Spacing",
                "props": {
                    "Height": "20px",
                    "id": "Spacing-7fdc1b22-ce98-4403-8631-95d3e6644b27"
                }
            },
            {
                "type": "Text",
                "props": {
                    "Text": {
                        "text": "Lorem ipsum dolor sit amet",
                        "FontSize": "fs-20",
                        "FontWeight": "fw-400",
                        "Color": "#000000",
                        "Align": "center"
                    },
                    "id": "Text-bf8e0769-4cc5-48dd-9220-30efa5f92980"
                }
            },
            {
                "type": "Spacing",
                "props": {
                    "Height": "40px",
                    "id": "Spacing-8a9a652a-6d84-4d36-9bae-360b0190fe41"
                }
            },
            {
                "type": "WhiteCards",
                "props": {
                    "Settings": {
                        "Border": {
                            "BorderStyle": "solid",
                            "BorderWidth": 1,
                            "BorderRadius": 4,
                            "BorderColor": "#C1C7CF"
                        },
                        "Card": {
                            "Padding": {
                                "top": 13,
                                "right": 13,
                                "bottom": 13,
                                "left": 13
                            },
                            "UniqueID": "Section_ID2",
                            "IconSize": 48
                        },
                        "Text": {
                            "TitleFont": "fs-38",
                            "TitleFontWeight": "fw-700",
                            "TitleColor": "#000",
                            "DescriptionFont": "fs-20",
                            "DescriptionFontWeight": "fw-400",
                            "DescriptionColor": "#000",
                            "Align": "center"
                        }
                    },
                    "Lists": [
                        {
                            "Image": "/static/media/icon.ab8ba87e320a2b6214c74915b3a986e2.svg",
                            "Title": "Microsoft 365",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        },
                        {
                            "Image": "/static/media/icon.ab8ba87e320a2b6214c74915b3a986e2.svg",
                            "Title": "Subheading ",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        },
                        {
                            "Image": "/static/media/icon.ab8ba87e320a2b6214c74915b3a986e2.svg",
                            "Title": "Subheading ",
                            "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                        }
                    ],
                    "id": "WhiteCards-c057a6f6-0cfe-404d-945f-ecbfdaedf95f"
                }
            }
        ]
    }
}

const OneYearChartOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    series: [
        {
            name: 'Actual Benefits with Vodafone',
            type: 'pie',
            radius: '50%',
            color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
            data: [
                { value: 1048, name: 'Lower Costs' },
                { value: 735, name: 'Increase Productivity' },
                { value: 580, name: 'Enable Business' },

            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};

const ThreeYearChartOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2022', '2023', '2024']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [

        {
            name: 'Lower Costs',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#9C2AA0' // Apply purple color here
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: 'Increase Productivity',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#EB9700' // Apply orange color here
            },
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: 'Enable Business',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#00B0CA' // Apply cyan color here
            },
            data: [150, 232, 201, 154, 190, 330, 410]
        },



    ]
};

const chartStyle = {
    height: '300px',
    width: '100%',
}


const config = {

    components: {

        //Header Components
        PageHeader: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Menu items",
                    arrayFields: {
                        Text: { type: "text" },
                        Action: {
                            type: "select",
                            label: "Choose action",
                            options: [
                                { label: "Open Page", value: "action-1" },
                                { label: "Show Block", value: "action-2" },
                                { label: "Hide Block", value: "action-3" },
                                { label: "Open Popup", value: "action-4" },
                            ],
                        },
                    },
                    getItemSummary: (item) => item.Text || "Item",
                    defaultItemProps: {
                        Text: "Menu item",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                logo: Logo,
                items: [
                    { Text: "License", },
                    { Text: "Discovery", },
                    { Text: "Results", },

                ]
            },


            render: ({ logo, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <div className='roi-header-main' style={{ opacity: inputOpacity }}>
                        <div className="container">
                            <div className="header-wrapper">
                                <Link to="" className="logo">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </Link>
                                <div className="nav-menu">
                                    <ul>
                                        {items.map((item, i) => (
                                            <li key={i}>
                                                <Link to="">{item.Text}</Link>
                                            </li>
                                        ))}
                                        {/* <li>
                                            <Link to="" className='active'>License</Link>
                                        </li>
                                        <li>
                                            <Link href="" className='disabled'>Discovery</Link>
                                        </li>
                                        <li>
                                            <Link href="" className='disabled'>Results</Link>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className='space'></div>
                            </div>
                        </div>
                    </div>
                )
            },
        },
        PageHeaderTransparent: {
            fields: {
                fields: {
                    logo: {
                        type: "custom",
                        label: "Add logo",
                        render: ({ name, onChange, value, field }) => (
                            <>
                                <FieldLabel label={field.label}></FieldLabel>

                                <input
                                    type="file"
                                    id='uploadImage'
                                    className='d-none'
                                    // defaultValue={value}
                                    name={name}
                                    onChange={(e) => onChange(e.currentTarget.value)}
                                />
                                <label htmlFor="uploadImage" className='icon-upload'>
                                    {/**Render remove button when icon is uploaded**/}
                                    <button className='remove-btn'>
                                        <Svg name="remove-icn-roi" />
                                    </button>
                                    <div className="img-wrapper">
                                        <img src={Logo} className='img-fluid' alt="" />
                                    </div>

                                </label>


                            </>
                        ),
                    },

                    hide: {
                        type: "custom",
                        label: "Hide",
                        render: ({ name, onChange, value, field }) => (
                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                    <div className="check-switch">
                                        <input
                                            type="checkbox"
                                            defaultChecked={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.checked)} />
                                    </div>
                                </div>
                            </>
                        ),
                        // We need to add defaultProps for the "hide" field
                        defaultProps: {
                            value: false, // Initially, the input should not be hidden
                        },
                    },


                },
                defaultProps: {
                    logo: Logo,
                },
            },

            render: ({ logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <div className='roi-header-transparent' style={{ opacity: inputOpacity }}>
                        <div className="container">
                            <div className="header-wrapper">
                                <a className="logo">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                )
            },
        },

        // Banner Layouts
        BannerLeftTextRightImage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },


                Style: {
                    type: "radio",
                    label: "Section style",
                    options: [
                        { label: "Style 1", value: "style1" },
                        { label: "Style 2", value: "style2" },
                    ],
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: [
                                { value: 1, label: 'Jump to page' },
                                { value: 2, label: 'Jump to URL' },
                                { value: 'OpenPopup', label: 'Open Popup' },
                            ],
                        },
                        popupTargetId: {
                            type: "custom",
                            label: "Popup Target ID",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        PageList: {
                            type: "select",
                            label: "Select page",
                            options: [
                                { value: 1, label: 'Landing Page' },
                                { value: 2, label: 'Report Page' },
                            ],
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },



                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={bannerImageLaptop} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },

                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                Heading: {
                    title: "TCO Calculator",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "<p>Explore your Vodafone plan options effortlessly with our Assessment Calculator tool. Simply input your usage details, preferences, and needs, and gain insights into the most suitable plans tailored to you. </p><p>From data allowances to international calls, the Assessment Calculator empowers you to make informed decisions about your telecommunications services. Say goodbye to guesswork and hello to personalized solutions with Vodafone's user-friendly tool, ensuring you get the most out of your mobile experience.</p>",
                    descriptionFont: "fs-20",
                },

                Style: "style1",

                Button: {
                    buttonText: "Start Assesment",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "no",
                    buttonAction: "",
                    popupTargetId: "",
                    PageList: ""
                },

                image: bannerImageLaptop,

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Button, Padding, Style, image, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                // Get popup ID for OpenPopup action
                const popupId = Button.popupTargetId ? Button.popupTargetId.trim().replace(/^#/, '') : '';
                
                // Handle button click - check for popup action
                const handleButtonClick = () => {
                    if (Button.buttonAction === "OpenPopup" && popupId) {
                        // Try to find and open the modal
                        const modalElement = document.getElementById(popupId);
                        if (modalElement && window.bootstrap) {
                            // Use getOrCreateInstance to prevent multiple instances
                            const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement, {
                                backdrop: 'static',
                                keyboard: false
                            });
                            modal.show();
                        } else {
                            console.warn(`Modal with id "${popupId}" not found`);
                        }
                    }
                };

                return (
                    <>
                        <div className={`roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Style} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="row align-items-center ">

                                    <div className="col-lg-6">
                                        <div className="banner-text">
                                            <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                            <div className="text-part">
                                                <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                </div>
                                            </div>

                                            <div className="button-wrap">
                                                {Button.buttonicon === "yes" ?

                                                    <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="button" onClick={handleButtonClick}><span className='with-icon'>{Button.buttonText}</span>
                                                        <div className="icon">
                                                            <Svg name="roi-button-icon" />
                                                        </div>
                                                    </button>
                                                    :
                                                    <button className={`btn roi-btn-${Button.buttonStyle}`} type="button" onClick={handleButtonClick}>{Button.buttonText}</button>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="img-wrapper">
                                            <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        BannerCenterText: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },

                Style: {
                    type: "radio",
                    label: "Section style",
                    options: [
                        { label: "Style 1", value: "style1" },
                        { label: "Style 2", value: "style2" },
                    ],
                },

                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus rutrum vitae lorem sed dignissim. Donec ut auctor lectus, ",
                    descriptionFont: "fs-22",
                },

                Style: "style1",

                Button: {
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },

                image: BgImage,

                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Button, Padding, image, Style, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: resolveMediaCssUrl(image), backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', opacity: inputOpacity }}>
                            <div className='overlay'></div>
                            <div className="container position-relative">
                                <div className="row align-items-center justify-content-center">

                                    <div className="col-lg-8">
                                        <div className="banner-text text-center">
                                            <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h1>

                                            <div className="text-part">
                                                <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                </div>
                                            </div>

                                            <div className="button-wrap">
                                                {Button.buttonicon === "yes" ?
                                                    <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                                        <div className="icon">
                                                            <Svg name="roi-button-icon" />
                                                        </div>
                                                    </button>
                                                    :
                                                    <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Cards Layouts
        CardLayout1: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },

                Card1: {
                    title: 'Card 1',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: [
                                { value: 1, label: 'Jump to page' },
                                { value: 2, label: 'Jump to URL' },
                            ],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page",
                            options: [
                                { value: 1, label: 'Landing Page' },
                                { value: 2, label: 'Report Page' },
                            ],
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },

                    },
                },

                Card2: {
                    title: 'Card 2',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: [
                                { value: 1, label: 'Jump to page' },
                                { value: 2, label: 'Jump to URL' },
                            ],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page",
                            options: [
                                { value: 1, label: 'Landing Page' },
                                { value: 2, label: 'Report Page' },
                            ],
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                    },
                },

                Card3: {
                    title: 'Card 3',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonAction: {
                            type: "select",
                            label: "Action on button click",
                            options: [
                                { value: 1, label: 'Jump to page' },
                                { value: 2, label: 'Jump to URL' },
                            ],
                        },
                        PageList: {
                            type: "select",
                            label: "Select page",
                            options: [
                                { value: 1, label: 'Landing Page' },
                                { value: 2, label: 'Report Page' },
                            ],
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                    },
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },

                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",

                },
                Card1: {
                    title: "Card 1",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""
                },
                Card2: {
                    title: "Card 2",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""

                },
                Card3: {
                    title: "Card 3",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    buttonAction: "",
                    buttonLink: "",
                    PageList: ""
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },

            },
            render: ({ Heading, Description, Padding, Card1, Card2, Card3, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="section-heading mb-3 mb-md-5 text-center">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.descriptionFont}>{Description.text}</p>
                                </div>
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card1.title}</h4>
                                                        <p>{Card1.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card2.title}</h4>
                                                        <p>{Card2.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4>{Card3.title}</h4>
                                                        <p>{Card3.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        CardLayout2: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },

                Card1: {
                    title: 'Card 1',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Card2: {
                    title: 'Card 2',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Card3: {
                    title: 'Card 3',
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        text: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },

                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",
                },
                Card1: {
                    title: "Card 1",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },
                Card2: {
                    title: "Card 2",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },
                Card3: {
                    title: "Card 3",
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Padding, Card1, Card2, Card3, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="section-heading mb-3 mb-md-5 text-center">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.descriptionFont}>{Description.text}</p>
                                </div>
                                <div className="cards-wrapper">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card1.title}</h4>
                                                        <p>{Card1.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card2.title}</h4>
                                                        <p>{Card2.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card-outer">
                                                <div className="card-inner">
                                                    <div className="icon-wrapper">
                                                        <Svg name="roi-card-icon" />
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <h4>{Card3.title}</h4>
                                                        <p>{Card3.text}</p>
                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Form Layouts
        SinglePage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "35px", value: "fs-35" },
                                { label: "40px", value: "fs-40" },
                                { label: "45px", value: "fs-45" },
                                { label: "50px", value: "fs-50" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "Heading goes here",
                    fontWeight: "fw-700",
                    titleFont: "fs-40",
                },

                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                    descriptionFont: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>

                            <div className="container position-relative">
                                <div className="form-wrapper">
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.descriptionFont}>{Description.text}</p>
                                    </div>
                                    <div className="form-inner">
                                        <DropZone zone="form-wrapper" disallow={["SinglePage", "WizardForm"]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        WizardForm: {

            fields: {

                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                        Description: "Section description",
                    },

                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },
                items: [
                    { Title: "Company", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Technology", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                    { Title: "Staff", Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " },
                ]
            },
            render: ({ Padding, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">

                                    {items.map((item, i) => (
                                        <li className="nav-item" role="presentation" key={i}>
                                            {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                            <button className={i === 0 ? 'nav-link active' : 'nav-link'} id={`tab-${i}`} data-bs-toggle="tab" data-bs-target={`#tab-${i}-pane`} type="button" role="tab" aria-controls={`tab-${i}-pane`} aria-selected="false">{item.Title}</button>
                                        </li>
                                    ))}
                                </ul>
                                <div className="form-wrapper">
                                    <div className="tab-content" id="myTabContent">
                                        {items.map((item, i) => (
                                            <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>
                                                <div className="section-heading mb-3 mb-md-4">
                                                    <h2 className={`heading fw-700 fs-40`}>{item.Title}</h2>
                                                    <p className='fs-22'>{item.Description}</p>
                                                </div>
                                                <div className="form-inner">
                                                    <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </>
                )

            },
        },

        //Form Elements

        InputTextField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Label",
                placeholder: "Placeholder",
                value: "Value",
                hint: '',
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, value, placeholder, required, errorMessage, hint, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="position-relative">
                                <input type="text" value={value} className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} />
                                {hint &&
                                    <div className="hint">
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </div>

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        InputNumberField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "number",
                    label: "Value",

                },

                Prefix: {
                    type: "select",
                    label: "Prefix/Postfix",
                    options: [
                        { label: "None", value: "none" },
                        { label: "%", value: "%" },
                        { label: "Currency", value: "currency" },

                    ],
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                hint: {
                    type: "custom",
                    label: "Hint",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <textarea
                                defaultValue={value}
                                className='form-control'
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}

                            />
                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Label",
                placeholder: "Placeholder",
                value: '',
                hint: '',
                required: false,
                Prefix: "none",
                // errorMessage: "Error message",
            },
            render: ({ label, value, placeholder, required, errorMessage, hint, hide, Prefix }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="position-relative">
                                {Prefix == 'none' &&
                                    <input type="number" value={value} className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} />
                                }

                                {Prefix == '%' &&
                                    <div className="input-group percent">
                                        <input type="number" value={value} className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} />
                                        <span className="input-group-text">%</span>
                                    </div>

                                }

                                {Prefix == 'currency' &&
                                    <div className="input-group currency">
                                        <span className="input-group-text">$</span>
                                        {/**Change this currency depending upon default currency**/}
                                        <input type="number" value={value} className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} />

                                    </div>
                                }



                                {hint &&
                                    <div className="hint">
                                        <button className="info"><Svg name="hint-button" /></button>
                                        <div className="popover" dangerouslySetInnerHTML={{ __html: hint }}>
                                        </div>
                                    </div>
                                }
                            </div>

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        TextareaField: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Value",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },
                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Textarea",
                value: "Value",
                placeholder: "Placeholder",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, value, placeholder, required, errorMessage, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <textarea className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} required={required} value={value} />

                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Dropdown: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Dropdown label",
                required: false,
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <select className={`form-control ${errorMessage ? 'error' : ''}`} >
                                <option value>--Select--</option>
                                {items.map((item, i) => (
                                    <option value={i}>{item.Option}</option>
                                ))}
                            </select>


                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        Checkbox: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Checkbox label",
                required: false,
                ID: 'CheckBox1',
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                            <div className="roi-check-wrap">
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="checkbox" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.Option}
                                        </label>
                                    </div>
                                ))}

                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Radio: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                items: {
                    type: "array",
                    label: "Options",
                    arrayFields: {
                        Option: { type: "text" },
                    },
                    getItemSummary: (item) => item.Option || "Options",
                    defaultItemProps: {
                        Option: "Enter option",
                    },
                },

                ID: {
                    type: "custom",
                    label: "Unique ID",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Radio button label",
                required: false,
                ID: 'RadioButton1',
                items: [
                    {
                        Option: "Option 1",
                    },
                    {
                        Option: "Option 2",
                    }

                ],
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, items, ID, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                            <div className="roi-check-wrap">
                                {items.map((item, i) => (

                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" name={ID} type="radio" defaultValue id={`${ID}-${i}`} />
                                        <label className="form-check-label" htmlFor={`${ID}-${i}`}>
                                            {item.Option}
                                        </label>
                                    </div>
                                ))}

                            </div>
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },


        PhoneNumber: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Phone number",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Phone number",
                placeholder: "Enter phone number",
                value: "+91 3335 335353",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, placeholder, required, errorMessage, value, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Email: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                value: {
                    type: "custom",
                    label: "Email",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                        </>
                    ),
                },

                placeholder: {
                    type: "custom",
                    label: "Placeholder",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Email",
                placeholder: "Enter email",
                value: "admin@testmail.com",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, placeholder, required, errorMessage, value, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}
                        </div>
                    </>
                )

            },
        },

        Date: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
                errorMessage: {
                    type: "custom",
                    label: "Custom error text",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

            },
            defaultProps: {
                label: "Date",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required, errorMessage, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                            <DateField />
                            {errorMessage && <div className="input-error">{errorMessage}</div>}

                        </div>
                    </>
                )

            },
        },

        Range: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },
                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },

                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                label: "Range",

                required: false,
            },
            render: ({ label, required, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                            <Range />

                        </div>
                    </>
                )

            },
        },

        Toggle: {
            fields: {
                label: {
                    type: "custom",
                    label: "Label",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>
                            <input
                                defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />

                        </>
                    ),
                },

                conditionalLogic: {
                    type: "custom",
                    label: "Conditional Logic",
                    render: ({ field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="action-switch">
                                    <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                        <Svg name="edit-condition" />
                                    </button>
                                </div>

                            </div>
                        </>
                    ),
                },


                required: {
                    type: "custom",
                    label: "Required",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>

                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                label: "Toggle button",
                required: false,
                // errorMessage: "Error message",
            },
            render: ({ label, required, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="roi-form-group mb-3 position-relative" style={{ opacity: inputOpacity }}>
                            {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}
                            <div className="check-switch">
                                <label>No</label>
                                <input
                                    id="agree-check"
                                    type="checkbox"
                                    defaultChecked
                                />
                                <label>Yes</label>

                            </div>

                        </div>
                    </>
                )

            },
        },

        Button: {
            fields: {
                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        conditionalLogic: {
                            type: "custom",
                            label: "Conditional Logic",
                            render: ({ field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="action-switch">
                                            <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                                <Svg name="edit-condition" />
                                            </button>
                                        </div>

                                    </div>
                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Button: {
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },
            },
            render: ({ Button, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="button-wrap" style={{ opacity: inputOpacity }}>
                            {Button.buttonicon === "yes" ?

                                <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                    <div className="icon">
                                        <Svg name="roi-button-icon" />
                                    </div>
                                </button>
                                :
                                <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                            }

                        </div>
                    </>
                )

            },
        },


        //Report
        ReportPage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Heading: {
                    title: "How much could you save with VBUC?",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">

                                <div className="section-heading mb-3 mb-md-4">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>

                                <div className="stats-section">


                                    <div className="row">
                                        <div className="col-lg-9">
                                            <DropZone zone="card-wrapper" />
                                        </div>

                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <DropZone zone="total-wrapper" />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-8 col-md-12 mb-3">
                                            <DropZone zone="chart-wrapper" />
                                        </div>
                                        <div className="col-lg-4 col-md-12 mb-3">
                                            <DropZone zone="download-wrapper" />

                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>


                    </>
                )

            },
        },

        CardSection: {
            fields: {
                items: {
                    type: "array",
                    label: "Card Sections",
                    arrayFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                        ActionText: { type: "text" },
                        Action: {
                            type: "select",
                            label: "Choose action",
                            options: [
                                { label: "Open Page", value: "action-1" },
                                { label: "Open Popup", value: "action-2" },
                            ],

                        },
                    },
                    getItemSummary: (item) => item.Title || "Card",
                    defaultItemProps: {
                        Title: "Card title",
                        Description: "Card description",
                        ActionText: "Action",
                        icon: CardIcon
                    },

                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                items: [
                    {
                        Title: "Lower Costs",
                        Description: "£288,342",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Increase Productivity",
                        Description: "£18,100",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Enable Business",
                        Description: "£495,900",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                ]

            },
            render: ({ items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="row" style={{ opacity: inputOpacity }}>
                            {items.map((item, i) => (
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <div className="stat-wrap">
                                        <div className="stat-heading">
                                            <div className="icon">
                                                <img src={resolveMediaUrl(item.icon)} alt="" />
                                            </div>
                                            <div className={`text fs-20 fw-700`}>{item.Title}</div>
                                        </div>
                                        <div className="stat-content-wrapper">
                                            <div className={`cost fs-48 fw-300`}>{item.Description}</div>
                                            <div className="action">
                                                <a href="" className='fs-16 fw-700'>{item.ActionText} <span className="icon">
                                                    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                        <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            },
        },

        ResultCard: {
            fields: {
                Card1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                Card2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Card1: {
                    title: "Total First Year Subscription",
                    description: "£802, 850",
                },
                Card2: {
                    title: "Total Three Year Subscription",
                    description: "£2,408,551",
                },
            },
            render: ({ Card1, Card2, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                            <div className="total-inner bg-1">
                                <h5 className='fs-16 fw-700'>{Card1.title}</h5>
                                <p className='fs-48 fw-300'>{Card1.description}</p>
                            </div>
                            <div className="total-inner bg-2">
                                <h5 className='fs-16 fw-700'>{Card2.title}</h5>
                                <p className='fs-48 fw-300'>{Card2.description}</p>
                            </div>
                        </div>

                    </>
                )
            },
        },

        ChartCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "14px", value: "fs-14" },
                                { label: "16px", value: "fs-16" },
                                { label: "18px", value: "fs-18" },
                                { label: "20px", value: "fs-20" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Chart1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },

                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },
                Chart2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                Heading: {
                    title: "Actual Benefits with Vodafone",
                    fontWeight: "fw-700",
                    titleFont: "fs-20",
                    icon: CardIcon
                },

                Chart1: {
                    title: "First Year",
                    chooseChart: "pie",
                    items: [
                        {
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
                Chart2: {
                    title: "Three Year",
                    chooseChart: "bar",
                    items: [
                        {
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
            },
            render: ({ Chart1, Chart2, Heading, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                            <div className="stat-heading">
                                <div className="icon">
                                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                                </div>
                                <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>

                                <div className="switch-btn">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="tab-1-tab" data-bs-toggle="tab" data-bs-target="#tab-1-tab-pane" type="button"
                                                role="tab" aria-controls="tab-1-tab-pane" aria-selected="true">{Chart1.title}</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="tab-2-tab" data-bs-toggle="tab" data-bs-target="#tab-2-tab-pane" type="button"
                                                role="tab" aria-controls="tab-2-tab-pane" aria-selected="false">{Chart2.title}</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="stat-content-wrapper">
                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active" id="tab-1-tab-pane" role="tabpanel" aria-labelledby="tab-1-tab" tabIndex={0}>
                                        {Chart1.chooseChart === "pie" ? <ReactEcharts style={chartStyle} option={OneYearChartOptions} /> : <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} />}
                                    </div>
                                    <div className="tab-pane fade" id="tab-2-tab-pane" role="tabpanel" aria-labelledby="tab-2-tab" tabIndex={0}>
                                        {Chart2.chooseChart === "bar" ? <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} /> : <ReactEcharts style={chartStyle} option={OneYearChartOptions} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "25px", value: "fs-25" },
                                { label: "30px", value: "fs-30" },
                                { label: "35px", value: "fs-35" },
                                { label: "40px", value: "fs-40" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },
                    },
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },



                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Savings report",
                    fontWeight: "fw-700",
                    titleFont: "fs-30",
                },


                Button: {
                    buttonText: "Button",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },

                image: "https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png",

            },
            render: ({ Heading, Button, image, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`save-report-section h-100 d-flex align-items-end`} style={{ backgroundImage: resolveMediaCssUrl(image), backgroundPosition: 'center', backgroundSize: 'cover', opacity: inputOpacity }}>

                            <div className="text-wrapper">
                                <h4 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h4>

                                <div class="button-wrap">

                                    {Button.buttonicon === "yes" ?
                                        <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                            <div className="icon">
                                                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </button>
                                        :
                                        <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        //Report Single page


        ReportSection: {

            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Lower Costs",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "Access all of the numbers behind the Lower Costs calculations, with the opportunity to change some numbers.",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },
                items: [
                    { Title: "Cost of Phone Provisioning" },
                    { Title: "Downtime" },
                    { Title: "IT Integrations" },
                    { Title: "Security and Compliance" },
                    { Title: "Employee Retention and Engagement" },
                ]
            },
            render: ({ Heading, Description, Padding, items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`} style={{ opacity: inputOpacity }}>
                            <div className="container position-relative">
                                <div className="section-heading mb-3 mb-md-4">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>
                                <div className="report-accordion-wrapper">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">

                                        {items.map((item, i) => (
                                            <li className="nav-item" role="presentation" key={i}>
                                                {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                                                <button className={i === 0 ? 'nav-link active' : 'nav-link'} id={`tab-${i}`} data-bs-toggle="tab" data-bs-target={`#tab-${i}-pane`} type="button" role="tab" aria-controls={`tab-${i}-pane`} aria-selected="false">{item.Title}</button>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="form-wrapper">
                                        <div className="tab-content" id="myTabContent">
                                            {items.map((item, i) => (
                                                <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>

                                                    <div className="form-inner">
                                                        <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </>
                )

            },
        },

        ReportTable: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },
                Table: {
                    type: "object",
                    objectFields: {

                        Columns: {
                            type: "number",
                            label: "Columns per Row",
                        },

                        FirstRow: {
                            type: "custom",
                            label: "First Row as Heading",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        LastRow: {
                            type: "custom",
                            label: "Last Row as Result",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                ColumnSettings: {
                    type: "object",
                    objectFields: {
                        FirstColSpan: {
                            type: "text",
                            label: "1st column width",
                        },
                        SecondColSpan: {
                            type: "text",
                            label: "2nd Column width",
                        },
                        ThirdColSpan: {
                            type: "text",
                            label: "3rd Column width",
                        },
                        FourthColSpan: {
                            type: "text",
                            label: "4th Column width",
                        },

                        HighlightCol: {
                            type: 'select',
                            label: 'Highlight Column',
                            options: [
                                { label: "None", value: "none" },
                                { label: "1st", value: "1st" },
                                { label: "2nd", value: "2nd" },
                                { label: "3rd", value: "3rd" },
                                { label: "4th", value: "4th" },
                            ],
                        }
                    },

                },


                Headings: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Cell 1",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Cell 2",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Cell 3",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Cell 4",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },

                items: {
                    type: "array",
                    label: "Rows",
                    arrayFields: {
                        Cell1Data: {
                            type: "custom",
                            label: "Cell 1 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Cell1isEditable: {
                            type: "custom",
                            label: "Cell 1 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        Cell2Data: {
                            type: "custom",
                            label: "Cell 2 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },

                        Cell2isEditable: {
                            type: "custom",
                            label: "Cell 2 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),

                        },

                        Cell2EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },


                        Cell3Data: {
                            type: "custom",
                            label: "Cell 3 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3isEditable: {
                            type: "custom",
                            label: "Cell 3 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell3EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },
                        Cell4Data: {
                            type: "custom",
                            label: "Cell 4 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },
                        Cell4isEditable: {
                            type: "custom",
                            label: "Cell 4 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell4EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },
                    },
                    getItemSummary: (item) => item.Cell1Data || "Row",
                    defaultItemProps: {
                        Title: "Row",
                        Cell1Data: "Text here",
                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",
                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",
                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",

                    },

                },

                Calculations: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Reducing Communications Downtime",
                },
                Table: {
                    Rows: 4,
                    Columns: 4,
                    FirstRow: true,
                    LastRow: true,
                },
                ColumnSettings: {
                    FirstColSpan: '',
                    SecondColSpan: '135',
                    ThirdColSpan: '150',
                    FourthColSpan: '210',
                    HighlightCol: "3rd",
                },
                Headings: {
                    Cell1: "",
                    Cell2: "Current",
                    Cell3: "With Vodafone",
                    Cell4: "Saving with Vodafone",
                },
                items: [
                    {
                        Cell1Data: "Text here",
                        Cell1isEditable: false,

                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",

                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",

                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",
                    },

                ],
                Calculations: {
                    Cell1: "Result",
                    Cell2: "1",
                },


            },
            render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="accordion-item" style={{ opacity: inputOpacity }}>
                            <h2 className="fs-20 fw-700 accordion-button">
                                {Heading.title}
                            </h2>
                            <div className="accordion-body">
                                <div className="table-wrapper">
                                    <div className="table-responsive">
                                        <table class="table">
                                            {Table.FirstRow && <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                </tr>
                                            </thead>}

                                            <tbody>
                                                {items.map((item, i) => (
                                                    <tr key={i}>
                                                        <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                            {item.Cell1isEditable ?
                                                                <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} /> :
                                                                item.Cell1Data
                                                            }
                                                        </td>


                                                        <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell2Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell2Data
                                                                    );
                                                                }

                                                                else if (item.Cell2isEditable && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell2Data
                                                                    );
                                                                }
                                                            })()}

                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell3Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell3Data
                                                                    );
                                                                }

                                                                else if (item.Cell3isEditable && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell3Data
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                            {(() => {
                                                                if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell4Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell4Data
                                                                    );
                                                                }

                                                                else if (item.Cell4isEditable && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell4Data
                                                                    );
                                                                }
                                                            })()}



                                                        </td>
                                                    </tr>
                                                ))}




                                            </tbody>
                                            {Table.LastRow && <tfoot>
                                                <tr>
                                                    <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                    <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                    <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                </tr>
                                            </tfoot>}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },


        // Download Report 
        DownloadReportBanner: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={LogoWhite} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        descriptionFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                    },
                },


                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={bannerImageLaptop} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

                backgroundImage: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={BgImage} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },

                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },
                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },


            },
            defaultProps: {
                logo: LogoWhite,
                Heading: {
                    title: "TCO Calculator",
                    fontWeight: "fw-700",
                    titleFont: "fs-55",
                },

                Description: {
                    text: "<p>Explore your Vodafone plan options effortlessly with our Assessment Calculator tool. Simply input your usage details, preferences, and needs, and gain insights into the most suitable plans tailored to you. </p><p>From data allowances to international calls, the Assessment Calculator empowers you to make informed decisions about your telecommunications services. Say goodbye to guesswork and hello to personalized solutions with Vodafone's user-friendly tool, ensuring you get the most out of your mobile experience.</p>",
                    descriptionFont: "fs-20",
                },

                image: bannerImageLaptop,
                backgroundImage: BgImage,

                Padding: {
                    top: "pt-30",
                    bottom: "p3-60",
                    fullHeight: true,
                },
            },
            render: ({ Heading, Description, Padding, logo, image, backgroundImage, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: resolveMediaCssUrl(backgroundImage), backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="row align-items-center ">
                                        <div className="col-lg-12">
                                            <div className="banner-text">
                                                <h1 className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}>{Heading.title}</h1>

                                                <div className="text-part">
                                                    <div className={Description.descriptionFont} dangerouslySetInnerHTML={{ __html: Description.text }}>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="img-wrapper">
                                                <img src={resolveMediaUrl(image)} className='img-fluid' alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },
        DownloadReportPage: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "How much could you save with VBUC?",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },

            },
            render: ({ Heading, Description, Padding, logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>

                                    <div className="stats-section">
                                        <div className="row">
                                            <div className="col-lg-12 mb-2">
                                                <DropZone zone="card-wrapper" />
                                            </div>

                                            <div className="col-lg-12 mb-2">
                                                <DropZone zone="total-wrapper" />

                                            </div>

                                            <div className="col-lg-12">
                                                <DropZone zone="chart-wrapper" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadCardSection: {
            fields: {
                items: {
                    type: "array",
                    label: "Card Sections",
                    arrayFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        Title: { type: "text" },
                        Description: { type: "textarea" },

                    },
                    getItemSummary: (item) => item.Title || "Card",
                    defaultItemProps: {
                        Title: "Card title",
                        Description: "Card description",
                        icon: CardIcon
                    },

                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                items: [
                    {
                        Title: "Lower Costs",
                        Description: "£288,342",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Increase Productivity",
                        Description: "£18,100",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                    {
                        Title: "Enable Business",
                        Description: "£495,900",
                        ActionText: "Explore and Adjust",
                        icon: CardIcon
                    },
                ]

            },
            render: ({ items, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="row gx-2" style={{ opacity: inputOpacity }}>
                            {items.map((item, i) => (
                                <div className="col-lg-4 col-md-4 mb-2">
                                    <div className="stat-wrap">
                                        <div className="stat-heading">
                                            <div className="icon">
                                                <img src={resolveMediaUrl(item.icon)} alt="" />
                                            </div>
                                            <div className={`text fs-14 fw-700`}>{item.Title}</div>
                                        </div>
                                        <div className="stat-content-wrapper">
                                            <div className={`cost fs-35 fw-400`}>{item.Description}</div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            },
        },

        DownloadResultCard: {
            fields: {
                Card1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                Card2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },
            },
            defaultProps: {
                Card1: {
                    title: "Total First Year Subscription",
                    description: "£802, 850",
                },
                Card2: {
                    title: "Total Three Year Subscription",
                    description: "£2,408,551",
                },
            },
            render: ({ Card1, Card2, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="total-wrapper row gx-0 flex-row" style={{ opacity: inputOpacity }}>
                            <div className="total-inner bg-1 col-6">
                                <h5 className='fs-16 fw-700 text-center'>{Card1.title}</h5>
                                <p className='fs-48 fw-300 text-center'>{formatRoiCurrencyDescription(Card1.description)}</p>
                            </div>
                            <div className="total-inner bg-2 col-6">
                                <h5 className='fs-16 fw-700 text-center'>{Card2.title}</h5>
                                <p className='fs-48 fw-300 text-center'>{formatRoiCurrencyDescription(Card2.description)}</p>
                            </div>
                        </div>

                    </>
                )
            },
        },

        DownloadChartCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        icon: {
                            type: "custom",
                            label: "Add icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={CardIcon} className='img-fluid contain' alt="" />
                                        </div>

                                    </label>


                                </>
                            ),
                        },
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Chart1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },

                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },
                Chart2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        items: {
                            type: "array",
                            label: "Chart",
                            arrayFields: {
                                Text: { type: "text" },
                                Data: { type: "text" },
                                Color: { type: "text" },
                            },
                            getItemSummary: (item) => item.Text || "Card",
                            defaultItemProps: {
                                Text: "Indicator",
                                Data: 100,
                                Color: "#9C2AA0",
                            },

                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },
                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                Heading: {
                    title: "Actual Benefits with Vodafone",
                    fontWeight: "fw-700",
                    titleFont: "fs-20",
                    icon: CardIcon
                },

                Chart1: {
                    title: "First Year",
                    chooseChart: "pie",
                    items: [
                        {
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
                Chart2: {
                    title: "Three Year",
                    chooseChart: "bar",
                    items: [
                        {
                            Text: "Lower Costs",
                            Data: 1048,
                            Color: "#9C2AA0",
                        },
                        {
                            Text: "Increase Productivity",
                            Data: 735,
                            Color: "#EB9700",
                        },
                        {
                            Text: "Enable Business",
                            Data: 580,
                            Color: "#00B0CA",
                        },

                    ]
                },
            },
            render: ({ Chart1, Chart2, Heading, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                            <div className="stat-heading">
                                <div className="icon">
                                    <img src={resolveMediaUrl(Heading.icon)} alt="" />
                                </div>
                                <div className={`text ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</div>


                            </div>

                            <div className="stat-content-wrapper">
                                <div className="tab-content" id="myTabContent">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            {Chart1.chooseChart === "pie" ? <ReactEcharts style={chartStyle} option={OneYearChartOptions} /> : <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} />}
                                        </div>
                                        <div className="col-sm-6">
                                            {Chart2.chooseChart === "bar" ? <ReactEcharts style={chartStyle} option={ThreeYearChartOptions} /> : <ReactEcharts style={chartStyle} option={OneYearChartOptions} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            },
        },

        DownloadReportSection: {

            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
                items: {
                    type: "array",
                    label: "Form Sections",
                    arrayFields: {
                        Title: { type: "text" },
                    },
                    getItemSummary: (item) => item.Title || "Section",
                    defaultItemProps: {
                        Title: "Section title",
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "Lower Costs",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "Access all of the numbers behind the Lower Costs calculations, with the opportunity to change some numbers.",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },
                items: [
                    { Title: "Cost of Phone Provisioning" },
                    { Title: "Downtime" },
                    { Title: "IT Integrations" },
                    { Title: "Security and Compliance" },
                    { Title: "Employee Retention and Engagement" },
                ]
            },
            render: ({ Heading, Description, Padding, items, logo, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>

                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>
                                    <div className="report-accordion-wrapper">

                                        <div className="form-wrapper">
                                            <div className="tab-content" id="myTabContent">
                                                {items.map((item, i) => (
                                                    <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}>

                                                        <div className="form-inner">
                                                            <DropZone zone={`wizard-form-wrapper-${i}`} disallow={["SinglePage", "WizardForm"]} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },

        DownloadReportTable: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },
                Table: {
                    type: "object",
                    objectFields: {

                        Columns: {
                            type: "number",
                            label: "Columns per Row",
                        },

                        FirstRow: {
                            type: "custom",
                            label: "First Row as Heading",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        LastRow: {
                            type: "custom",
                            label: "Last Row as Result",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },

                },

                ColumnSettings: {
                    type: "object",
                    objectFields: {
                        FirstColSpan: {
                            type: "text",
                            label: "1st column width",
                        },
                        SecondColSpan: {
                            type: "text",
                            label: "2nd Column width",
                        },
                        ThirdColSpan: {
                            type: "text",
                            label: "3rd Column width",
                        },
                        FourthColSpan: {
                            type: "text",
                            label: "4th Column width",
                        },

                        HighlightCol: {
                            type: 'select',
                            label: 'Highlight Column',
                            options: [
                                { label: "None", value: "none" },
                                { label: "1st", value: "1st" },
                                { label: "2nd", value: "2nd" },
                                { label: "3rd", value: "3rd" },
                                { label: "4th", value: "4th" },
                            ],
                        }
                    },

                },


                Headings: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Cell 1",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Cell 2",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3: {
                            type: "custom",
                            label: "Cell 3",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell4: {
                            type: "custom",
                            label: "Cell 4",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                },

                items: {
                    type: "array",
                    label: "Rows",
                    arrayFields: {
                        Cell1Data: {
                            type: "custom",
                            label: "Cell 1 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Cell1isEditable: {
                            type: "custom",
                            label: "Cell 1 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        Cell2Data: {
                            type: "custom",
                            label: "Cell 2 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },

                        Cell2isEditable: {
                            type: "custom",
                            label: "Cell 2 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),

                        },

                        Cell2EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },


                        Cell3Data: {
                            type: "custom",
                            label: "Cell 3 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell3isEditable: {
                            type: "custom",
                            label: "Cell 3 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell3EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },
                        Cell4Data: {
                            type: "custom",
                            label: "Cell 4 Data",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),

                        },
                        Cell4isEditable: {
                            type: "custom",
                            label: "Cell 4 Editable",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                        Cell4EditStyle: {
                            type: "radio",
                            label: "Field Type",
                            options: [
                                { label: "Number", value: "number" },
                                { label: "%", value: "percentage" },
                                { label: "£", value: "euro" },
                            ],
                        },
                    },
                    getItemSummary: (item) => item.Cell1Data || "Row",
                    defaultItemProps: {
                        Title: "Row",
                        Cell1Data: "Text here",
                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",
                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",
                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",

                    },

                },

                Calculations: {
                    type: "object",
                    objectFields: {
                        Cell1: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Cell2: {
                            type: "custom",
                            label: "Value",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                Heading: {
                    title: "Reducing Communications Downtime",
                },
                Table: {
                    Rows: 4,
                    Columns: 4,
                    FirstRow: true,
                    LastRow: true,
                },
                ColumnSettings: {
                    FirstColSpan: '',
                    SecondColSpan: '135',
                    ThirdColSpan: '150',
                    FourthColSpan: '210',
                    HighlightCol: "3rd",
                },
                Headings: {
                    Cell1: "",
                    Cell2: "Current",
                    Cell3: "With Vodafone",
                    Cell4: "Saving with Vodafone",
                },
                items: [
                    {
                        Cell1Data: "Text here",
                        Cell1isEditable: false,

                        Cell2Data: "1",
                        Cell2isEditable: false,
                        Cell2EditStyle: "number",

                        Cell3Data: "1",
                        Cell3isEditable: false,
                        Cell3EditStyle: "number",

                        Cell4Data: "1",
                        Cell4isEditable: false,
                        Cell4EditStyle: "number",
                    },

                ],
                Calculations: {
                    Cell1: "Result",
                    Cell2: "1",
                },


            },
            render: ({ Heading, Table, Headings, ColumnSettings, items, Calculations, Test, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="accordion-item" style={{ opacity: inputOpacity }}>
                            <h2 className="fs-14 fw-700 accordion-button">
                                {Heading.title}
                            </h2>
                            <div className="accordion-body">
                                <div className="table-wrapper">
                                    <div className="table-responsive">
                                        <table class="table">
                                            {Table.FirstRow && <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }} className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>{Headings.Cell1}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>{Headings.Cell2}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }} className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>{Headings.Cell3}</th>
                                                    <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }} className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>{Headings.Cell4}</th>
                                                </tr>
                                            </thead>}

                                            <tbody>
                                                {items.map((item, i) => (
                                                    <tr key={i}>
                                                        <td className={`${ColumnSettings.HighlightCol === '1st' ? 'highlighted' : ''}`}>
                                                            {item.Cell1isEditable ?
                                                                <input type="text" className="form-control first-column" defaultValue={item.Cell1Data} /> :
                                                                item.Cell1Data
                                                            }
                                                        </td>


                                                        <td className={`${ColumnSettings.HighlightCol === '2nd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell2isEditable && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell2Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell2isEditable) && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell2Data
                                                                    );
                                                                }

                                                                else if (item.Cell2isEditable && item.Cell2EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell2isEditable && item.Cell2EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell2Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell2Data
                                                                    );
                                                                }
                                                            })()}

                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '3rd' ? 'highlighted' : ''} text-end`}>
                                                            {(() => {
                                                                if (item.Cell3isEditable && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell3Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell3isEditable) && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell3Data
                                                                    );
                                                                }

                                                                else if (item.Cell3isEditable && item.Cell3EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell3isEditable && item.Cell3EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell3Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell3Data
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td className={`${ColumnSettings.HighlightCol === '4th' ? 'highlighted' : ''} text-end`}>

                                                            {(() => {
                                                                if (item.Cell4isEditable && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">%</span>
                                                                        </div>
                                                                    );

                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'percentage') {
                                                                    return (
                                                                        item.Cell4Data + '%'
                                                                    );
                                                                }
                                                                else if (!(item.Cell4isEditable) && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        '£' + item.Cell4Data
                                                                    );
                                                                }

                                                                else if (item.Cell4isEditable && item.Cell4EditStyle === 'euro') {
                                                                    return (
                                                                        <div className="input-group">
                                                                            <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                            <span className="input-group-text" id="basic-addon2">£</span>
                                                                        </div>
                                                                    );
                                                                } else if (item.Cell4isEditable && item.Cell4EditStyle === 'number') {
                                                                    return (
                                                                        <input type="text" className="form-control" aria-describedby="basic-addon2" defaultValue={item.Cell4Data} />
                                                                    );
                                                                } else {
                                                                    return (
                                                                        item.Cell4Data
                                                                    );
                                                                }
                                                            })()}



                                                        </td>
                                                    </tr>
                                                ))}




                                            </tbody>
                                            {Table.LastRow && <tfoot>
                                                <tr>
                                                    <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                    <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                    <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                    <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                </tr>
                                            </tfoot>}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </>
                )

            },
        },


        DownloadReportCardsSection: {
            fields: {
                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={Logo} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                    },
                },

                Lists: {
                    type: "array",
                    getItemSummary: (item) => item.label || "List",
                    arrayFields: {
                        Image: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={icon} className='img-fluid' alt="" />
                                        </div>

                                    </label>
                                </>
                            ),
                        },
                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        ButtonText: {
                            type: "custom",
                            label: "Button Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        ButtonLink: {
                            type: "custom",
                            label: "Button link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                    },
                    defaultItemProps: {
                        Image: icon,
                        Title: "Medium length section heading goes here",
                        Description: "Lorem ipsum dolor sit amet",
                        ButtonLink: "#",
                        ButtonText: "Button"
                    },
                },

                Settings: {
                    type: "object",
                    objectFields: {

                        TitleFont: {
                            label: "Title font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        TitleFontWeight: {
                            label: "Title font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                        TitleColor: {
                            type: "custom",
                            label: "Title Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        DescriptionFont: {
                            label: "Description font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        DescriptionFontWeight: {
                            label: "Description font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                        DescriptionColor: {
                            type: "custom",
                            label: "Description Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        ItemsPerRow: {
                            label: "Items per row",
                            type: "select",
                            options: [
                                { label: "1", value: "1" },
                                { label: "2", value: "2" },
                                { label: "3", value: "3" },
                                { label: "4", value: "4" },
                                { label: "5", value: "5" },
                                { label: "6", value: "6" },
                            ],
                        },

                        ShowIcon: {
                            type: "custom",
                            label: "Show Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                        IconPosition: {
                            label: "Image Position",
                            type: "radio",
                            options: [
                                { label: "Top", value: "top" },
                                { label: "Left", value: "left" },
                            ],
                        },

                        ShowButton: {
                            type: "custom",
                            label: "Show Button",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },

                    },
                },


                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {
                logo: Logo,
                Heading: {
                    title: "Explore these resources for improving productivity and enhancing meeting effectiveness.",
                    fontWeight: "fw-700",
                    titleFont: "fs-22",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-30",
                    bottom: "pb-30",
                },

                Settings: {
                    TitleFont: "fs-20",
                    TitleFontWeight: "fw-700",
                    TitleColor: "#000000",
                    DescriptionFont: "fs-16",
                    DescriptionFontWeight: "fw-400",
                    DescriptionColor: "#000000",
                    ItemsPerRow: '1',
                    ShowIcon: true,
                    IconPosition: "left",
                    ShowButton: true
                },
                Lists: [
                    {
                        Image: icon,
                        Title: "Medium length section heading goes here",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
                        ButtonText: "Explore",
                        ButtonLink: "#"
                    }
                ],

            },
            render: ({ Heading, Description, Padding, logo, Lists, Settings, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                                <div className="container position-relative">
                                    <div className="logo-wrap">
                                        <Link to="">
                                            <img src={resolveMediaUrl(logo)} alt="" />
                                        </Link>
                                    </div>
                                    <div className="section-heading mb-3 mb-md-4">
                                        <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        <p className={Description.Font}>{Description.text}</p>
                                    </div>
                                    <div className="report-posts-wrapper">

                                        <div className="list-box-1 d-grid gap-4" style={{ gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`, }}>
                                            {Lists.map((list, i) => (
                                                <div className={`list-box-inner ${Settings.IconPosition === 'left' ? 'd-flex' : ''}`} key={i}>
                                                    {Settings.ShowIcon ? <div className="icon-wrap">
                                                        <img src={resolveMediaUrl(list.Image)} alt="" />
                                                    </div> : ""}

                                                    <div className={`text-wrap flex-grow-1`}>
                                                        <h4 className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`} style={{ color: Settings.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}>{list.Description}</p>
                                                        {Settings.ShowButton
                                                            ? <div className="button-wrap pt-3">
                                                                <a className="link d-inline-flex text-primary fw-700 fs-14 align-items-center" href={list.ButtonLink}>
                                                                    <span>{list.ButtonText}</span> <Svg name="button-arrow" />
                                                                </a>
                                                            </div>
                                                            :
                                                            ""}

                                                    </div>
                                                </div>

                                            ))}


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>
                )

            },
        },

        DownloadReportThankYou: {
            fields: {

                logo: {
                    type: "custom",
                    label: "Add logo",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src={LogoThankYou} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                    },
                },

                hide: {
                    type: "custom",
                    label: "Hide",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <div className="d-flex justify-content-between align-items-center">
                                <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                <div className="check-switch">
                                    <input
                                        type="checkbox"
                                        defaultChecked={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.checked)} />
                                </div>
                            </div>
                        </>
                    ),
                    // We need to add defaultProps for the "hide" field
                    defaultProps: {
                        value: false, // Initially, the input should not be hidden
                    },
                },

            },
            defaultProps: {

                logo: LogoThankYou,
                Description: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc nulla velit, faucibus ut massa a, vulputate euismod leo. Suspendisse potenti. Aenean mollis ",
                    Font: "fs-14",
                },
            },
            render: ({ logo, Description, hide }) => {
                // Calculate opacity based on hide value
                const inputOpacity = hide ? 0.5 : 1;

                return (
                    <>
                        <div className="portrait-report-wrapper" style={{ opacity: inputOpacity }}>
                            <div className="report-build-wrapper report-thankyou">
                                <div className="logo-wrap">
                                    <img src={resolveMediaUrl(logo)} alt="" />
                                </div>
                                <div className="desclaimer">
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


        // Landing Page components
        TransparentSection: {
            fields: {

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Background: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    {/* <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                         defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    /> */}
                                    {/* <label htmlFor="uploadImage" className='icon-upload'>

                                        
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div>
                                    </label> */}
                                    <div className="position-relative upload">

                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="icon-upload" data-bs-toggle="modal" data-bs-target="#fileUpload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </div>


                                </>
                            ),
                        },
                        Width: {
                            type: "select",
                            label: "Show in",
                            options: [
                                { label: "Container", value: "container" },
                                { label: "Full Width", value: "container-fluid" },
                                { label: "Edge to edge", value: "container-fluid p-0" },
                            ],
                        },
                    },
                }


            },
            defaultProps: {
                Style: {
                    Background: "",
                    BackgroundColor: "#fff",
                    Width: "container"
                },


                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: false,
                },
            },
            render: ({ Padding, Style }) => {

                return (
                    <>
                        <div className={`component-section ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: resolveMediaCssUrl(Style.Background), backgroundColor: `${Style.BackgroundColor}`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                            {/* <div className='overlay'></div> */}
                            <div className={`${Style.Width} position-relative`}>
                                <DropZone zone="section" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        GradientSection: {
            fields: {

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                                { label: "Extra Large", value: "pt-150" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                                { label: "Extra Large", value: "pb-150" },
                            ],
                        },

                        fullHeight: {
                            type: "custom",
                            label: "Show full height",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="check-switch">
                                            <input
                                                type="checkbox"
                                                defaultChecked={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.checked)} />
                                        </div>
                                    </div>

                                </>
                            ),
                        },
                    },
                },
                Style: {
                    type: "object",
                    objectFields: {

                        Width: {
                            type: "select",
                            label: "Show in",
                            options: [
                                { label: "Container", value: "container" },
                                { label: "Full Width", value: "container-fluid" },
                                { label: "Edge to edge", value: "container-fluid p-0" },
                            ],
                        },
                    },
                }
            },
            defaultProps: {
                Style: {

                    Width: "container"
                },

                Padding: {
                    top: "pt-150",
                    bottom: "pb-150",
                    fullHeight: false,
                },
            },
            render: ({ Padding, Style }) => {

                return (
                    <>
                        <div className={`component-section gradient-bg ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`}>
                            {/* <div className='overlay'></div> */}
                            <div className={`${Style.Width} position-relative`}>
                                <DropZone zone="section" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        Columns: {
            fields: {
                distribution: {
                    type: "radio",
                    options: [
                        { value: "auto", label: "Auto", },
                        { value: "manual", label: "Manual", },
                    ],
                },
                vertical: {
                    label: "Vertical Align",
                    type: "select",
                    options: [
                        { label: "Top", value: "align-items-start" },
                        { label: "Middle", value: "align-items-center" },
                        { label: "Bottom", value: "align-items-end" },

                    ],
                },
                gap: {
                    label: "Column gap",
                    type: "number",
                },

                columns: {
                    type: "array",
                    getItemSummary: (col, id) =>
                        `Column ${id + 1}, span ${col.span ? Math.max(Math.min(col.span, 12), 1) : "auto"
                        }`,
                    arrayFields: {
                        span: {
                            label: "Span (1-12)",
                            type: "number",
                            min: 0,
                            max: 12,
                        },
                        backgroundColor: {
                            type: "text",
                            label: "Background color",
                        }
                    },
                },
            },
            defaultProps: {
                distribution: "manual",
                vertical: "align-items-center",
                gap: 20,
                columns: [{}, {}],
            },

            render: ({ columns, distribution, vertical, gap, backgroundColor }) => {

                return (
                    <div
                        className={`d-grid section-column ${vertical}`}
                        style={{

                            gridTemplateColumns:
                                distribution === "manual"
                                    ? "repeat(12, 1fr)"
                                    : `repeat(${columns.length}, 1fr)`,
                            gridColumnGap: `${gap}px`
                        }}
                    >
                        {columns.map(({ span, backgroundColor }, idx) => (
                            <div
                                key={idx}
                                className="w-100"
                                style={{
                                    display: "flex",
                                    backgroundColor: backgroundColor,
                                    flexDirection: "column",
                                    gridColumn:
                                        span && distribution === "manual"
                                            ? `span ${Math.max(Math.min(span, 12), 1)}`
                                            : "",
                                }}
                            >
                                <DropZone
                                    zone={`column-${idx}`}
                                // disallow={["Section"]}
                                />
                            </div>
                        ))}
                    </div>
                )

            },

        },

        Wrapper: {
            fields: {

                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "number",
                        },

                        bottom: {
                            label: "Bottom",
                            type: "number",
                        },
                        left: {
                            label: "Left",
                            type: "number",
                        },
                        right: {
                            label: "Right",
                            type: "number",
                        },


                    },
                },
                Style: {
                    type: "object",
                    objectFields: {
                        BackgroundColor: {
                            type: "custom",
                            label: "Background Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Background: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    {/* <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                         defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    /> */}
                                    {/* <label htmlFor="uploadImage" className='icon-upload'>

                                        
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div>
                                    </label> */}
                                    <div className="position-relative upload">

                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="icon-upload" data-bs-toggle="modal" data-bs-target="#fileUpload">
                                            {/**Render remove button when icon is uploaded**/}
                                            <span>Upload image</span>
                                            {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                        </div>
                                    </div>


                                </>
                            ),
                        },


                    },
                },

                Border: {
                    type: "object",
                    objectFields: {
                        BorderStyle: {
                            label: "Border style",
                            type: "select",
                            options: [
                                { label: "dashed", value: "dashed" },
                                { label: "dotted", value: "dotted" },
                                { label: "solid", value: "solid" },
                                { label: "none", value: "none" },
                            ],
                        },
                        BorderWidth: {
                            label: "Border Width",
                            type: "select",
                            options: [
                                { label: "none", value: 0 },
                                { label: "1", value: 1 },
                                { label: "2", value: 2 },
                                { label: "3", value: 3 },
                                { label: "4", value: 4 },
                                { label: "5", value: 5 },
                                { label: "6", value: 6 },
                                { label: "7", value: 7 },
                                { label: "8", value: 8 },
                                { label: "9", value: 9 },
                                { label: "10", value: 10 },
                            ],
                        },
                        BorderColor: {
                            type: "custom",
                            label: "Border Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        BorderRadius: {
                            label: "Border radius",
                            type: "select",
                            options: [
                                { label: "none", value: 0 },
                                { label: "1", value: 1 },
                                { label: "2", value: 2 },
                                { label: "3", value: 3 },
                                { label: "4", value: 4 },
                                { label: "5", value: 5 },
                                { label: "6", value: 6 },
                                { label: "7", value: 7 },
                                { label: "8", value: 8 },
                                { label: "9", value: 9 },
                                { label: "10", value: 10 },
                            ],
                        },
                    },
                },


            },
            defaultProps: {
                Style: {
                    Background: "",
                    BackgroundColor: "",
                },


                Padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                },

                Border: {
                    BorderStyle: "solid",
                    BorderWidth: 0,
                    BorderRadius: 0,
                    BorderColor: "#dedede"
                },
            },
            render: ({ Padding, Style, Border }) => {

                return (
                    <>
                        <div className={`component-wrapper`}
                            style={
                                {
                                    backgroundImage: resolveMediaCssUrl(Style.Background),
                                    backgroundColor: `${Style.BackgroundColor}`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover',
                                    padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                                    borderStyle: Border.BorderStyle,
                                    borderColor: Border.BorderColor,
                                    borderWidth: `${Border.BorderWidth}px`,
                                    borderRadius: `${Border.BorderRadius}px`,
                                }
                            }>
                            {/* <div className='overlay'></div> */}
                            <div className={`position-relative`}>
                                <DropZone zone="wrapper" />
                            </div>
                        </div>
                    </>
                )

            },
        },

        Spacing: {
            fields: {
                Height: {
                    label: "Spacing",
                    type: "select",
                    options: [
                        { label: "0px", value: "0px" },
                        { label: "1px", value: "1px" },
                        { label: "2px", value: "2px" },
                        { label: "3px", value: "3px" },
                        { label: "4px", value: "4px" },
                        { label: "5px", value: "5px" },
                        { label: "6px", value: "6px" },
                        { label: "7px", value: "7px" },
                        { label: "8px", value: "8px" },
                        { label: "9px", value: "9px" },
                        { label: "10px", value: "10px" },
                        { label: "11px", value: "11px" },
                        { label: "12px", value: "12px" },
                        { label: "13px", value: "13px" },
                        { label: "14px", value: "14px" },
                        { label: "15px", value: "15px" },
                        { label: "16px", value: "16px" },
                        { label: "17px", value: "17px" },
                        { label: "18px", value: "18px" },
                        { label: "19px", value: "19px" },
                        { label: "20px", value: "20px" },
                        { label: "21px", value: "21px" },
                        { label: "22px", value: "22px" },
                        { label: "23px", value: "23px" },
                        { label: "24px", value: "24px" },
                        { label: "25px", value: "25px" },
                        { label: "26px", value: "26px" },
                        { label: "27px", value: "27px" },
                        { label: "28px", value: "28px" },
                        { label: "29px", value: "29px" },
                        { label: "30px", value: "30px" },
                        { label: "31px", value: "31px" },
                        { label: "32px", value: "32px" },
                        { label: "33px", value: "33px" },
                        { label: "34px", value: "34px" },
                        { label: "35px", value: "35px" },
                        { label: "36px", value: "36px" },
                        { label: "37px", value: "37px" },
                        { label: "38px", value: "38px" },
                        { label: "39px", value: "39px" },
                        { label: "40px", value: "40px" },
                        { label: "41px", value: "41px" },
                        { label: "42px", value: "42px" },
                        { label: "43px", value: "43px" },
                        { label: "44px", value: "44px" },
                        { label: "45px", value: "45px" },
                        { label: "46px", value: "46px" },
                        { label: "47px", value: "47px" },
                        { label: "48px", value: "48px" },
                        { label: "49px", value: "49px" },
                        { label: "50px", value: "50px" },
                        { label: "51px", value: "51px" },
                        { label: "52px", value: "52px" },
                        { label: "53px", value: "53px" },
                        { label: "54px", value: "54px" },
                        { label: "55px", value: "55px" },
                        { label: "56px", value: "56px" },
                        { label: "57px", value: "57px" },
                        { label: "58px", value: "58px" },
                        { label: "59px", value: "59px" },
                        { label: "60px", value: "60px" },
                        { label: "61px", value: "61px" },
                        { label: "62px", value: "62px" },
                        { label: "63px", value: "63px" },
                        { label: "64px", value: "64px" },
                        { label: "65px", value: "65px" },
                        { label: "66px", value: "66px" },
                        { label: "67px", value: "67px" },
                        { label: "68px", value: "68px" },
                        { label: "69px", value: "69px" },
                        { label: "70px", value: "70px" },
                        { label: "71px", value: "71px" },
                        { label: "72px", value: "72px" },
                        { label: "73px", value: "73px" },
                        { label: "74px", value: "74px" },
                        { label: "75px", value: "75px" },
                        { label: "76px", value: "76px" },
                        { label: "77px", value: "77px" },
                        { label: "78px", value: "78px" },
                        { label: "79px", value: "79px" },
                        { label: "80px", value: "80px" },
                        { label: "81px", value: "81px" },
                        { label: "82px", value: "82px" },
                        { label: "83px", value: "83px" },
                        { label: "84px", value: "84px" },
                        { label: "85px", value: "85px" },
                        { label: "86px", value: "86px" },
                        { label: "87px", value: "87px" },
                        { label: "88px", value: "88px" },
                        { label: "89px", value: "89px" },
                        { label: "90px", value: "90px" },
                        { label: "91px", value: "91px" },
                        { label: "92px", value: "92px" },
                        { label: "93px", value: "93px" },
                        { label: "94px", value: "94px" },
                        { label: "95px", value: "95px" },
                        { label: "96px", value: "96px" },
                        { label: "97px", value: "97px" },
                        { label: "98px", value: "98px" },
                        { label: "99px", value: "99px" },
                        { label: "100px", value: "100px" }
                    ],
                },
            },
            defaultProps: {
                Height: '10px'
            },
            render: ({ Height }) => {

                return (
                    <div style={{ height: `${Height}` }}></div>
                )

            },
        },

        Heading: {
            fields: {
                Text: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        tag: {
                            type: "radio",
                            options: [
                                { label: "h1", value: "h1" },
                                { label: "h2", value: "h2" },
                                { label: "h3", value: "h3" },
                                { label: "h4", value: "h4" },
                                { label: "h5", value: "h5" },
                                { label: "h6", value: "h6" },
                            ],
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Align: {
                            label: "Text align",
                            type: "select",
                            options: [
                                { label: "Left", value: "left" },
                                { label: "Center", value: "center" },
                                { label: "Right", value: "right" },
                                { label: "Justify", value: "justify" },
                            ],
                        },
                    },
                },
            },
            defaultProps: {
                Text: {
                    title: "Enter title here",
                    titleFont: "fs-16",
                    fontWeight: "fw-700",
                    tag: "h1",
                    Color: "#000000",
                    Align: "left"
                }
            },
            render: ({ Text }) => {

                return (
                    <>
                        {(() => {
                            if (Text.tag === 'h1') {
                                return (
                                    <h1
                                        className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h1>
                                );
                            }
                            else if (Text.tag === 'h2') {
                                return (
                                    <h2
                                        className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h2>
                                );
                            }
                            else if (Text.tag === 'h3') {
                                return (
                                    <h3 className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div>
                                    </h3>
                                );
                            }
                            else if (Text.tag === 'h4') {
                                return (
                                    <h4 className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h4>
                                );
                            }
                            else if (Text.tag === 'h5') {
                                return (
                                    <h5 className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h5>
                                );
                            }
                            else if (Text.tag === 'h6') {
                                return (
                                    <h6 className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                                        style={{
                                            color: `${Text.Color}`,
                                            textAlign: Text.Align
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: Text.title }}>
                                        </div></h6>
                                );
                            }
                        })()}

                    </>
                )

            },
        },

        Text: {
            fields: {
                Text: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>

                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                        FontSize: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "10px", value: "fs-10" },
                                { label: "11px", value: "fs-11" },
                                { label: "12px", value: "fs-12" },
                                { label: "13px", value: "fs-13" },
                                { label: "14px", value: "fs-14" },
                                { label: "15px", value: "fs-15" },
                                { label: "16px", value: "fs-16" },
                                { label: "17px", value: "fs-17" },
                                { label: "18px", value: "fs-18" },
                                { label: "19px", value: "fs-19" },
                                { label: "20px", value: "fs-20" },
                                { label: "21px", value: "fs-21" },
                                { label: "22px", value: "fs-22" },
                                { label: "23px", value: "fs-23" },
                                { label: "24px", value: "fs-24" },
                                { label: "25px", value: "fs-25" },
                                { label: "26px", value: "fs-26" },
                                { label: "27px", value: "fs-27" },
                                { label: "28px", value: "fs-28" },
                                { label: "29px", value: "fs-29" },
                                { label: "30px", value: "fs-30" },
                                { label: "31px", value: "fs-31" },
                                { label: "32px", value: "fs-32" },
                                { label: "33px", value: "fs-33" },
                                { label: "34px", value: "fs-34" },
                                { label: "35px", value: "fs-35" },
                                { label: "36px", value: "fs-36" },
                                { label: "37px", value: "fs-37" },
                                { label: "38px", value: "fs-38" },
                                { label: "39px", value: "fs-39" },
                                { label: "40px", value: "fs-40" },
                                { label: "41px", value: "fs-41" },
                                { label: "42px", value: "fs-42" },
                                { label: "43px", value: "fs-43" },
                                { label: "44px", value: "fs-44" },
                                { label: "45px", value: "fs-45" },
                                { label: "46px", value: "fs-46" },
                                { label: "47px", value: "fs-47" },
                                { label: "48px", value: "fs-48" },
                                { label: "49px", value: "fs-49" },
                                { label: "50px", value: "fs-50" },
                                { label: "51px", value: "fs-51" },
                                { label: "52px", value: "fs-52" },
                                { label: "53px", value: "fs-53" },
                                { label: "54px", value: "fs-54" },
                                { label: "55px", value: "fs-55" },
                                { label: "56px", value: "fs-56" },
                                { label: "57px", value: "fs-57" },
                                { label: "58px", value: "fs-58" },
                                { label: "59px", value: "fs-59" },
                                { label: "60px", value: "fs-60" },
                                { label: "61px", value: "fs-61" },
                                { label: "62px", value: "fs-62" },
                                { label: "63px", value: "fs-63" },
                                { label: "64px", value: "fs-64" },
                                { label: "65px", value: "fs-65" },
                                { label: "66px", value: "fs-66" },
                                { label: "67px", value: "fs-67" },
                                { label: "68px", value: "fs-68" },
                                { label: "69px", value: "fs-69" },
                                { label: "70px", value: "fs-70" },
                                { label: "71px", value: "fs-71" },
                                { label: "72px", value: "fs-72" },
                                { label: "73px", value: "fs-73" },
                                { label: "74px", value: "fs-74" },
                                { label: "75px", value: "fs-75" },
                                { label: "76px", value: "fs-76" },
                                { label: "77px", value: "fs-77" },
                                { label: "78px", value: "fs-78" },
                                { label: "79px", value: "fs-79" },
                                { label: "80px", value: "fs-80" },
                                { label: "81px", value: "fs-81" },
                                { label: "82px", value: "fs-82" },
                                { label: "83px", value: "fs-83" },
                                { label: "84px", value: "fs-84" },
                                { label: "85px", value: "fs-85" },
                                { label: "86px", value: "fs-86" },
                                { label: "87px", value: "fs-87" },
                                { label: "88px", value: "fs-88" },
                                { label: "89px", value: "fs-89" },
                                { label: "90px", value: "fs-90" },
                                { label: "91px", value: "fs-91" },
                                { label: "92px", value: "fs-92" },
                                { label: "93px", value: "fs-93" },
                                { label: "94px", value: "fs-94" },
                                { label: "95px", value: "fs-95" },
                                { label: "96px", value: "fs-96" },
                                { label: "97px", value: "fs-97" },
                                { label: "98px", value: "fs-98" },
                                { label: "99px", value: "fs-99" },
                                { label: "100px", value: "fs-100" }
                            ],
                        },
                        FontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                        Color: {
                            type: "custom",
                            label: "Color",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                        Align: {
                            label: "Text align",
                            type: "select",
                            options: [
                                { label: "Left", value: "left" },
                                { label: "Center", value: "center" },
                                { label: "Right", value: "right" },
                                { label: "Justify", value: "justify" },
                            ],
                        },

                    },
                },
            },
            defaultProps: {
                Text: {
                    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
                    FontSize: "fs-16",
                    FontWeight: "fw-400",
                    Color: "#000000",
                    Align: "left",
                }
            },
            render: ({ Text }) => {

                return (
                    <>
                        <div
                            style={{
                                color: `${Text.Color}`,
                                textAlign: Text.Align
                            }}
                            className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`} dangerouslySetInnerHTML={{ __html: Text.text }}>
                        </div>
                    </>
                )

            },
        },

        Image: {
            fields: {
                Image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                {/* <span>Upload image</span> */}
                                <div className="img-wrapper">
                                    <img src={bannerImageLaptop} className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },
                AspectRatio: {
                    label: "Aspect Ratio",
                    type: "select",
                    options: [
                        { label: "auto", value: "auto" },
                        { label: "1/1", value: "1/1" },
                        { label: "2/3", value: "2/3" },
                        { label: "3/2", value: "3/2" },
                    ],
                },
            },
            defaultProps: {
                Image: bannerImageLaptop,
                AspectRatio: ''
            },
            render: ({ Image, AspectRatio }) => {

                return (
                    <>
                        <div className="image-wrapper">
                            <img src={resolveMediaUrl(Image)} alt="" className="img-fluid object-cover w-100" style={{ aspectRatio: `${AspectRatio}` }} />
                        </div>
                    </>
                )

            },
        },

        RedCards: {
            fields: {

                Lists: {
                    type: "array",
                    getItemSummary: (list) => list.Title || "List",
                    arrayFields: {

                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className="form-control"
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                    defaultItemProps: {
                        Title: "Subheading one",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    },
                },
                Settings: {
                    type: "object",
                    objectFields: {
                        conditionalLogic: {
                            type: "custom",
                            label: "Conditional Logic",
                            render: ({ field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="action-switch">
                                            <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                                <Svg name="edit-condition" />
                                            </button>
                                        </div>
        
                                    </div>
                                </>
                            ),
                        },

                        Border: {
                            type: "object",
                            objectFields: {
                                BorderStyle: {
                                    label: "Border style",
                                    type: "select",
                                    options: [
                                        { label: "dashed", value: "dashed" },
                                        { label: "dotted", value: "dotted" },
                                        { label: "solid", value: "solid" },
                                        { label: "none", value: "none" },
                                    ],
                                },
                                BorderWidth: {
                                    label: "Border Width",
                                    type: "select",
                                    options: [
                                        { label: "none", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                        { label: "3", value: 3 },
                                        { label: "4", value: 4 },
                                        { label: "5", value: 5 },
                                        { label: "6", value: 6 },
                                        { label: "7", value: 7 },
                                        { label: "8", value: 8 },
                                        { label: "9", value: 9 },
                                        { label: "10", value: 10 },
                                    ],
                                },
                                BorderColor: {
                                    type: "custom",
                                    label: "Border Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                BorderRadius: {
                                    label: "Border radius",
                                    type: "number",

                                },
                            },
                        },
                        Card: {
                            type: "object",
                            objectFields: {
                                Padding: {
                                    type: "object",
                                    objectFields: {
                                        top: {
                                            type: "number"
                                        },
                                        right: {
                                            type: "number"
                                        },
                                        bottom: {
                                            type: "number"
                                        },
                                        left: {
                                            type: "number"
                                        },
                                    }
                                },
                                BackgroundColor: {
                                    type: "custom",
                                    label: "Background color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                UniqueID: {
                                    type: "text",
                                }



                            },
                        },

                        Text: {
                            type: "object",
                            objectFields: {
                                TitleFont: {
                                    label: "Title font size",
                                    type: "select",
                                    options: [
                                        { label: "10px", value: "fs-10" },
                                        { label: "11px", value: "fs-11" },
                                        { label: "12px", value: "fs-12" },
                                        { label: "13px", value: "fs-13" },
                                        { label: "14px", value: "fs-14" },
                                        { label: "15px", value: "fs-15" },
                                        { label: "16px", value: "fs-16" },
                                        { label: "17px", value: "fs-17" },
                                        { label: "18px", value: "fs-18" },
                                        { label: "19px", value: "fs-19" },
                                        { label: "20px", value: "fs-20" },
                                        { label: "21px", value: "fs-21" },
                                        { label: "22px", value: "fs-22" },
                                        { label: "23px", value: "fs-23" },
                                        { label: "24px", value: "fs-24" },
                                        { label: "25px", value: "fs-25" },
                                        { label: "26px", value: "fs-26" },
                                        { label: "27px", value: "fs-27" },
                                        { label: "28px", value: "fs-28" },
                                        { label: "29px", value: "fs-29" },
                                        { label: "30px", value: "fs-30" },
                                        { label: "31px", value: "fs-31" },
                                        { label: "32px", value: "fs-32" },
                                        { label: "33px", value: "fs-33" },
                                        { label: "34px", value: "fs-34" },
                                        { label: "35px", value: "fs-35" },
                                        { label: "36px", value: "fs-36" },
                                        { label: "37px", value: "fs-37" },
                                        { label: "38px", value: "fs-38" },
                                        { label: "39px", value: "fs-39" },
                                        { label: "40px", value: "fs-40" },
                                        { label: "41px", value: "fs-41" },
                                        { label: "42px", value: "fs-42" },
                                        { label: "43px", value: "fs-43" },
                                        { label: "44px", value: "fs-44" },
                                        { label: "45px", value: "fs-45" },
                                        { label: "46px", value: "fs-46" },
                                        { label: "47px", value: "fs-47" },
                                        { label: "48px", value: "fs-48" },
                                        { label: "49px", value: "fs-49" },
                                        { label: "50px", value: "fs-50" },
                                        { label: "51px", value: "fs-51" },
                                        { label: "52px", value: "fs-52" },
                                        { label: "53px", value: "fs-53" },
                                        { label: "54px", value: "fs-54" },
                                        { label: "55px", value: "fs-55" },
                                        { label: "56px", value: "fs-56" },
                                        { label: "57px", value: "fs-57" },
                                        { label: "58px", value: "fs-58" },
                                        { label: "59px", value: "fs-59" },
                                        { label: "60px", value: "fs-60" },
                                        { label: "61px", value: "fs-61" },
                                        { label: "62px", value: "fs-62" },
                                        { label: "63px", value: "fs-63" },
                                        { label: "64px", value: "fs-64" },
                                        { label: "65px", value: "fs-65" },
                                        { label: "66px", value: "fs-66" },
                                        { label: "67px", value: "fs-67" },
                                        { label: "68px", value: "fs-68" },
                                        { label: "69px", value: "fs-69" },
                                        { label: "70px", value: "fs-70" },
                                        { label: "71px", value: "fs-71" },
                                        { label: "72px", value: "fs-72" },
                                        { label: "73px", value: "fs-73" },
                                        { label: "74px", value: "fs-74" },
                                        { label: "75px", value: "fs-75" },
                                        { label: "76px", value: "fs-76" },
                                        { label: "77px", value: "fs-77" },
                                        { label: "78px", value: "fs-78" },
                                        { label: "79px", value: "fs-79" },
                                        { label: "80px", value: "fs-80" },
                                        { label: "81px", value: "fs-81" },
                                        { label: "82px", value: "fs-82" },
                                        { label: "83px", value: "fs-83" },
                                        { label: "84px", value: "fs-84" },
                                        { label: "85px", value: "fs-85" },
                                        { label: "86px", value: "fs-86" },
                                        { label: "87px", value: "fs-87" },
                                        { label: "88px", value: "fs-88" },
                                        { label: "89px", value: "fs-89" },
                                        { label: "90px", value: "fs-90" },
                                        { label: "91px", value: "fs-91" },
                                        { label: "92px", value: "fs-92" },
                                        { label: "93px", value: "fs-93" },
                                        { label: "94px", value: "fs-94" },
                                        { label: "95px", value: "fs-95" },
                                        { label: "96px", value: "fs-96" },
                                        { label: "97px", value: "fs-97" },
                                        { label: "98px", value: "fs-98" },
                                        { label: "99px", value: "fs-99" },
                                        { label: "100px", value: "fs-100" }
                                    ],
                                },
                                TitleFontWeight: {
                                    label: "Title font weight",
                                    type: "select",
                                    options: [
                                        { label: "Regular", value: "fw-400" },
                                        { label: "Medium", value: "fw-500" },
                                        { label: "Semi-Medium", value: "fw-600" },
                                        { label: "Bold", value: "fw-700" },
                                    ],
                                },

                                TitleColor: {
                                    type: "custom",
                                    label: "Title Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                DescriptionFont: {
                                    label: "Description font size",
                                    type: "select",
                                    options: [
                                        { label: "10px", value: "fs-10" },
                                        { label: "11px", value: "fs-11" },
                                        { label: "12px", value: "fs-12" },
                                        { label: "13px", value: "fs-13" },
                                        { label: "14px", value: "fs-14" },
                                        { label: "15px", value: "fs-15" },
                                        { label: "16px", value: "fs-16" },
                                        { label: "17px", value: "fs-17" },
                                        { label: "18px", value: "fs-18" },
                                        { label: "19px", value: "fs-19" },
                                        { label: "20px", value: "fs-20" },
                                        { label: "21px", value: "fs-21" },
                                        { label: "22px", value: "fs-22" },
                                        { label: "23px", value: "fs-23" },
                                        { label: "24px", value: "fs-24" },
                                        { label: "25px", value: "fs-25" },
                                        { label: "26px", value: "fs-26" },
                                        { label: "27px", value: "fs-27" },
                                        { label: "28px", value: "fs-28" },
                                        { label: "29px", value: "fs-29" },
                                        { label: "30px", value: "fs-30" },
                                        { label: "31px", value: "fs-31" },
                                        { label: "32px", value: "fs-32" },
                                        { label: "33px", value: "fs-33" },
                                        { label: "34px", value: "fs-34" },
                                        { label: "35px", value: "fs-35" },
                                        { label: "36px", value: "fs-36" },
                                        { label: "37px", value: "fs-37" },
                                        { label: "38px", value: "fs-38" },
                                        { label: "39px", value: "fs-39" },
                                        { label: "40px", value: "fs-40" },
                                        { label: "41px", value: "fs-41" },
                                        { label: "42px", value: "fs-42" },
                                        { label: "43px", value: "fs-43" },
                                        { label: "44px", value: "fs-44" },
                                        { label: "45px", value: "fs-45" },
                                        { label: "46px", value: "fs-46" },
                                        { label: "47px", value: "fs-47" },
                                        { label: "48px", value: "fs-48" },
                                        { label: "49px", value: "fs-49" },
                                        { label: "50px", value: "fs-50" },
                                        { label: "51px", value: "fs-51" },
                                        { label: "52px", value: "fs-52" },
                                        { label: "53px", value: "fs-53" },
                                        { label: "54px", value: "fs-54" },
                                        { label: "55px", value: "fs-55" },
                                        { label: "56px", value: "fs-56" },
                                        { label: "57px", value: "fs-57" },
                                        { label: "58px", value: "fs-58" },
                                        { label: "59px", value: "fs-59" },
                                        { label: "60px", value: "fs-60" },
                                        { label: "61px", value: "fs-61" },
                                        { label: "62px", value: "fs-62" },
                                        { label: "63px", value: "fs-63" },
                                        { label: "64px", value: "fs-64" },
                                        { label: "65px", value: "fs-65" },
                                        { label: "66px", value: "fs-66" },
                                        { label: "67px", value: "fs-67" },
                                        { label: "68px", value: "fs-68" },
                                        { label: "69px", value: "fs-69" },
                                        { label: "70px", value: "fs-70" },
                                        { label: "71px", value: "fs-71" },
                                        { label: "72px", value: "fs-72" },
                                        { label: "73px", value: "fs-73" },
                                        { label: "74px", value: "fs-74" },
                                        { label: "75px", value: "fs-75" },
                                        { label: "76px", value: "fs-76" },
                                        { label: "77px", value: "fs-77" },
                                        { label: "78px", value: "fs-78" },
                                        { label: "79px", value: "fs-79" },
                                        { label: "80px", value: "fs-80" },
                                        { label: "81px", value: "fs-81" },
                                        { label: "82px", value: "fs-82" },
                                        { label: "83px", value: "fs-83" },
                                        { label: "84px", value: "fs-84" },
                                        { label: "85px", value: "fs-85" },
                                        { label: "86px", value: "fs-86" },
                                        { label: "87px", value: "fs-87" },
                                        { label: "88px", value: "fs-88" },
                                        { label: "89px", value: "fs-89" },
                                        { label: "90px", value: "fs-90" },
                                        { label: "91px", value: "fs-91" },
                                        { label: "92px", value: "fs-92" },
                                        { label: "93px", value: "fs-93" },
                                        { label: "94px", value: "fs-94" },
                                        { label: "95px", value: "fs-95" },
                                        { label: "96px", value: "fs-96" },
                                        { label: "97px", value: "fs-97" },
                                        { label: "98px", value: "fs-98" },
                                        { label: "99px", value: "fs-99" },
                                        { label: "100px", value: "fs-100" }
                                    ],
                                },
                                DescriptionFontWeight: {
                                    label: "Description font weight",
                                    type: "select",
                                    options: [
                                        { label: "Regular", value: "fw-400" },
                                        { label: "Medium", value: "fw-500" },
                                        { label: "Semi-Medium", value: "fw-600" },
                                        { label: "Bold", value: "fw-700" },
                                    ],
                                },

                                DescriptionColor: {
                                    type: "custom",
                                    label: "Description Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                Align: {
                                    label: "Text align",
                                    type: "select",
                                    options: [
                                        { label: "Left", value: "left" },
                                        { label: "Center", value: "center" },
                                        { label: "Right", value: "right" },
                                        { label: "Justify", value: "justify" },
                                    ],
                                },
                            }
                        },

                    },
                },
            },
            defaultProps: {
                Settings: {
                    Border: {
                        BorderStyle: "solid",
                        BorderWidth: 3,
                        BorderRadius: 12,
                        BorderColor: "#e60000"
                    },
                    Card: {
                        Padding: {
                            top: 13,
                            right: 13,
                            bottom: 13,
                            left: 13,
                        },
                        UniqueID: "Section_ID",
                    },
                    Text: {
                        TitleFont: "fs-38",
                        TitleFontWeight: "fw-700",
                        TitleColor: "#fff",
                        DescriptionFont: "fs-20",
                        DescriptionFontWeight: "fw-400",
                        DescriptionColor: "#fff",
                        Align: "center"
                    },

                },
                Lists: [
                    {
                        Title: "Microsoft 365",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    }
                ],
            },
            render: ({ Lists, Settings }) => {

                return (
                    <>
                        <div className="roi-cards-section card-layout-1">
                            <div className="cards-wrapper">
                                <div className="row justify-content-center">
                                    {Lists.map((list, i) => (
                                        <div className="col-lg-4 col-md-6 mb-3"
                                            key={i}>
                                            <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                            <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                borderStyle: Settings.Border.BorderStyle,
                                                borderColor: Settings.Border.BorderColor,
                                                borderWidth: `${Settings.Border.BorderWidth}px`,
                                                borderRadius: `${Settings.Border.BorderRadius}px`,
                                                backgroundColor: Settings.Card.BackgroundColor,
                                                paddingTop: `${Settings.Card.Padding.top}px`,
                                                paddingRight: `${Settings.Card.Padding.right}px`,
                                                paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                paddingLeft: `${Settings.Card.Padding.left}px`,
                                                textAlign: Settings.Text.Align
                                            }}>



                                                <div className="card-inner">
                                                    <div className="text-wrapper">
                                                        <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

        WhiteCards: {
            fields: {

                Lists: {
                    type: "array",
                    getItemSummary: (list) => list.Title || "List",
                    arrayFields: {
                        Image: {
                            type: "custom",
                            label: "Add image",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
        
                                    <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadImage" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src={icon2} className='img-fluid' alt="" />
                                        </div>
        
                                    </label>
        
        
                                </>
                            ),
                        },
                        Title: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className='form-control'
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        Description: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        className="form-control"
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },

                    },
                    defaultItemProps: {
                        Image: icon2,
                        Title: "Subheading one",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    },
                },
                Settings: {
                    type: "object",
                    objectFields: {
                        conditionalLogic: {
                            type: "custom",
                            label: "Conditional Logic",
                            render: ({ field }) => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                        <div className="action-switch">
                                            <button title='Edit' className="action-btn" data-bs-toggle="modal" data-bs-target="#editPins">
                                                <Svg name="edit-condition" />
                                            </button>
                                        </div>

                                    </div>
                                </>
                            ),
                        },

                        Border: {
                            type: "object",
                            objectFields: {
                                BorderStyle: {
                                    label: "Border style",
                                    type: "select",
                                    options: [
                                        { label: "dashed", value: "dashed" },
                                        { label: "dotted", value: "dotted" },
                                        { label: "solid", value: "solid" },
                                        { label: "none", value: "none" },
                                    ],
                                },
                                BorderWidth: {
                                    label: "Border Width",
                                    type: "select",
                                    options: [
                                        { label: "none", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                        { label: "3", value: 3 },
                                        { label: "4", value: 4 },
                                        { label: "5", value: 5 },
                                        { label: "6", value: 6 },
                                        { label: "7", value: 7 },
                                        { label: "8", value: 8 },
                                        { label: "9", value: 9 },
                                        { label: "10", value: 10 },
                                    ],
                                },
                                BorderColor: {
                                    type: "custom",
                                    label: "Border Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                BorderRadius: {
                                    label: "Border radius",
                                    type: "number",

                                },
                            },
                        },
                        Card: {
                            type: "object",
                            objectFields: {
                                Padding: {
                                    type: "object",
                                    objectFields: {
                                        top: {
                                            type: "number"
                                        },
                                        right: {
                                            type: "number"
                                        },
                                        bottom: {
                                            type: "number"
                                        },
                                        left: {
                                            type: "number"
                                        },
                                    }
                                },
                                BackgroundColor: {
                                    type: "custom",
                                    label: "Background color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                IconSize: {
                                    type: "number",
                                },
                                UniqueID: {
                                    type: "text",
                                }
                            },
                        },

                        Text: {
                            type: "object",
                            objectFields: {
                                TitleFont: {
                                    label: "Title font size",
                                    type: "select",
                                    options: [
                                        { label: "10px", value: "fs-10" },
                                        { label: "11px", value: "fs-11" },
                                        { label: "12px", value: "fs-12" },
                                        { label: "13px", value: "fs-13" },
                                        { label: "14px", value: "fs-14" },
                                        { label: "15px", value: "fs-15" },
                                        { label: "16px", value: "fs-16" },
                                        { label: "17px", value: "fs-17" },
                                        { label: "18px", value: "fs-18" },
                                        { label: "19px", value: "fs-19" },
                                        { label: "20px", value: "fs-20" },
                                        { label: "21px", value: "fs-21" },
                                        { label: "22px", value: "fs-22" },
                                        { label: "23px", value: "fs-23" },
                                        { label: "24px", value: "fs-24" },
                                        { label: "25px", value: "fs-25" },
                                        { label: "26px", value: "fs-26" },
                                        { label: "27px", value: "fs-27" },
                                        { label: "28px", value: "fs-28" },
                                        { label: "29px", value: "fs-29" },
                                        { label: "30px", value: "fs-30" },
                                        { label: "31px", value: "fs-31" },
                                        { label: "32px", value: "fs-32" },
                                        { label: "33px", value: "fs-33" },
                                        { label: "34px", value: "fs-34" },
                                        { label: "35px", value: "fs-35" },
                                        { label: "36px", value: "fs-36" },
                                        { label: "37px", value: "fs-37" },
                                        { label: "38px", value: "fs-38" },
                                        { label: "39px", value: "fs-39" },
                                        { label: "40px", value: "fs-40" },
                                        { label: "41px", value: "fs-41" },
                                        { label: "42px", value: "fs-42" },
                                        { label: "43px", value: "fs-43" },
                                        { label: "44px", value: "fs-44" },
                                        { label: "45px", value: "fs-45" },
                                        { label: "46px", value: "fs-46" },
                                        { label: "47px", value: "fs-47" },
                                        { label: "48px", value: "fs-48" },
                                        { label: "49px", value: "fs-49" },
                                        { label: "50px", value: "fs-50" },
                                        { label: "51px", value: "fs-51" },
                                        { label: "52px", value: "fs-52" },
                                        { label: "53px", value: "fs-53" },
                                        { label: "54px", value: "fs-54" },
                                        { label: "55px", value: "fs-55" },
                                        { label: "56px", value: "fs-56" },
                                        { label: "57px", value: "fs-57" },
                                        { label: "58px", value: "fs-58" },
                                        { label: "59px", value: "fs-59" },
                                        { label: "60px", value: "fs-60" },
                                        { label: "61px", value: "fs-61" },
                                        { label: "62px", value: "fs-62" },
                                        { label: "63px", value: "fs-63" },
                                        { label: "64px", value: "fs-64" },
                                        { label: "65px", value: "fs-65" },
                                        { label: "66px", value: "fs-66" },
                                        { label: "67px", value: "fs-67" },
                                        { label: "68px", value: "fs-68" },
                                        { label: "69px", value: "fs-69" },
                                        { label: "70px", value: "fs-70" },
                                        { label: "71px", value: "fs-71" },
                                        { label: "72px", value: "fs-72" },
                                        { label: "73px", value: "fs-73" },
                                        { label: "74px", value: "fs-74" },
                                        { label: "75px", value: "fs-75" },
                                        { label: "76px", value: "fs-76" },
                                        { label: "77px", value: "fs-77" },
                                        { label: "78px", value: "fs-78" },
                                        { label: "79px", value: "fs-79" },
                                        { label: "80px", value: "fs-80" },
                                        { label: "81px", value: "fs-81" },
                                        { label: "82px", value: "fs-82" },
                                        { label: "83px", value: "fs-83" },
                                        { label: "84px", value: "fs-84" },
                                        { label: "85px", value: "fs-85" },
                                        { label: "86px", value: "fs-86" },
                                        { label: "87px", value: "fs-87" },
                                        { label: "88px", value: "fs-88" },
                                        { label: "89px", value: "fs-89" },
                                        { label: "90px", value: "fs-90" },
                                        { label: "91px", value: "fs-91" },
                                        { label: "92px", value: "fs-92" },
                                        { label: "93px", value: "fs-93" },
                                        { label: "94px", value: "fs-94" },
                                        { label: "95px", value: "fs-95" },
                                        { label: "96px", value: "fs-96" },
                                        { label: "97px", value: "fs-97" },
                                        { label: "98px", value: "fs-98" },
                                        { label: "99px", value: "fs-99" },
                                        { label: "100px", value: "fs-100" }
                                    ],
                                },
                                TitleFontWeight: {
                                    label: "Title font weight",
                                    type: "select",
                                    options: [
                                        { label: "Regular", value: "fw-400" },
                                        { label: "Medium", value: "fw-500" },
                                        { label: "Semi-Medium", value: "fw-600" },
                                        { label: "Bold", value: "fw-700" },
                                    ],
                                },

                                TitleColor: {
                                    type: "custom",
                                    label: "Title Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },

                                DescriptionFont: {
                                    label: "Description font size",
                                    type: "select",
                                    options: [
                                        { label: "10px", value: "fs-10" },
                                        { label: "11px", value: "fs-11" },
                                        { label: "12px", value: "fs-12" },
                                        { label: "13px", value: "fs-13" },
                                        { label: "14px", value: "fs-14" },
                                        { label: "15px", value: "fs-15" },
                                        { label: "16px", value: "fs-16" },
                                        { label: "17px", value: "fs-17" },
                                        { label: "18px", value: "fs-18" },
                                        { label: "19px", value: "fs-19" },
                                        { label: "20px", value: "fs-20" },
                                        { label: "21px", value: "fs-21" },
                                        { label: "22px", value: "fs-22" },
                                        { label: "23px", value: "fs-23" },
                                        { label: "24px", value: "fs-24" },
                                        { label: "25px", value: "fs-25" },
                                        { label: "26px", value: "fs-26" },
                                        { label: "27px", value: "fs-27" },
                                        { label: "28px", value: "fs-28" },
                                        { label: "29px", value: "fs-29" },
                                        { label: "30px", value: "fs-30" },
                                        { label: "31px", value: "fs-31" },
                                        { label: "32px", value: "fs-32" },
                                        { label: "33px", value: "fs-33" },
                                        { label: "34px", value: "fs-34" },
                                        { label: "35px", value: "fs-35" },
                                        { label: "36px", value: "fs-36" },
                                        { label: "37px", value: "fs-37" },
                                        { label: "38px", value: "fs-38" },
                                        { label: "39px", value: "fs-39" },
                                        { label: "40px", value: "fs-40" },
                                        { label: "41px", value: "fs-41" },
                                        { label: "42px", value: "fs-42" },
                                        { label: "43px", value: "fs-43" },
                                        { label: "44px", value: "fs-44" },
                                        { label: "45px", value: "fs-45" },
                                        { label: "46px", value: "fs-46" },
                                        { label: "47px", value: "fs-47" },
                                        { label: "48px", value: "fs-48" },
                                        { label: "49px", value: "fs-49" },
                                        { label: "50px", value: "fs-50" },
                                        { label: "51px", value: "fs-51" },
                                        { label: "52px", value: "fs-52" },
                                        { label: "53px", value: "fs-53" },
                                        { label: "54px", value: "fs-54" },
                                        { label: "55px", value: "fs-55" },
                                        { label: "56px", value: "fs-56" },
                                        { label: "57px", value: "fs-57" },
                                        { label: "58px", value: "fs-58" },
                                        { label: "59px", value: "fs-59" },
                                        { label: "60px", value: "fs-60" },
                                        { label: "61px", value: "fs-61" },
                                        { label: "62px", value: "fs-62" },
                                        { label: "63px", value: "fs-63" },
                                        { label: "64px", value: "fs-64" },
                                        { label: "65px", value: "fs-65" },
                                        { label: "66px", value: "fs-66" },
                                        { label: "67px", value: "fs-67" },
                                        { label: "68px", value: "fs-68" },
                                        { label: "69px", value: "fs-69" },
                                        { label: "70px", value: "fs-70" },
                                        { label: "71px", value: "fs-71" },
                                        { label: "72px", value: "fs-72" },
                                        { label: "73px", value: "fs-73" },
                                        { label: "74px", value: "fs-74" },
                                        { label: "75px", value: "fs-75" },
                                        { label: "76px", value: "fs-76" },
                                        { label: "77px", value: "fs-77" },
                                        { label: "78px", value: "fs-78" },
                                        { label: "79px", value: "fs-79" },
                                        { label: "80px", value: "fs-80" },
                                        { label: "81px", value: "fs-81" },
                                        { label: "82px", value: "fs-82" },
                                        { label: "83px", value: "fs-83" },
                                        { label: "84px", value: "fs-84" },
                                        { label: "85px", value: "fs-85" },
                                        { label: "86px", value: "fs-86" },
                                        { label: "87px", value: "fs-87" },
                                        { label: "88px", value: "fs-88" },
                                        { label: "89px", value: "fs-89" },
                                        { label: "90px", value: "fs-90" },
                                        { label: "91px", value: "fs-91" },
                                        { label: "92px", value: "fs-92" },
                                        { label: "93px", value: "fs-93" },
                                        { label: "94px", value: "fs-94" },
                                        { label: "95px", value: "fs-95" },
                                        { label: "96px", value: "fs-96" },
                                        { label: "97px", value: "fs-97" },
                                        { label: "98px", value: "fs-98" },
                                        { label: "99px", value: "fs-99" },
                                        { label: "100px", value: "fs-100" }
                                    ],
                                },
                                DescriptionFontWeight: {
                                    label: "Description font weight",
                                    type: "select",
                                    options: [
                                        { label: "Regular", value: "fw-400" },
                                        { label: "Medium", value: "fw-500" },
                                        { label: "Semi-Medium", value: "fw-600" },
                                        { label: "Bold", value: "fw-700" },
                                    ],
                                },

                                DescriptionColor: {
                                    type: "custom",
                                    label: "Description Color",
                                    render: ({ name, onChange, value, field }) => (
                                        <>
                                            <FieldLabel label={field.label}></FieldLabel>
                                            <input

                                                defaultValue={value}
                                                name={name}
                                                onChange={(e) => onChange(e.currentTarget.value)}
                                            />

                                        </>
                                    ),
                                },
                                Align: {
                                    label: "Text align",
                                    type: "select",
                                    options: [
                                        { label: "Left", value: "left" },
                                        { label: "Center", value: "center" },
                                        { label: "Right", value: "right" },
                                        { label: "Justify", value: "justify" },
                                    ],
                                },
                            }
                        },

                    },
                },
            },
            defaultProps: {
                Settings: {
                    Border: {
                        BorderStyle: "solid",
                        BorderWidth: 1,
                        BorderRadius: 4,
                        BorderColor: "#C1C7CF"
                    },
                    Card: {
                        Padding: {
                            top: 13,
                            right: 13,
                            bottom: 13,
                            left: 13,
                        },
                        UniqueID: "Section_ID2",
                        IconSize: 48,
                    },
                    Text: {
                        TitleFont: "fs-38",
                        TitleFontWeight: "fw-700",
                        TitleColor: "#000",
                        DescriptionFont: "fs-20",
                        DescriptionFontWeight: "fw-400",
                        DescriptionColor: "#000",
                        Align: "center"
                    },

                },
                Lists: [
                    {
                        Image: icon2,
                        Title: "Microsoft 365",
                        Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                    }
                ],
            },
            render: ({ Lists, Settings }) => {

                return (
                    <>
                        <div className="roi-cards-section card-layout-2">
                            <div className="cards-wrapper">
                                <div className="row justify-content-center">
                                    {Lists.map((list, i) => (
                                        <div className="col-lg-4 col-md-6 mb-3"
                                            key={i}>
                                            <input className="form-check-input d-none" type="radio" name={Settings.Card.UniqueID} id={`${Settings.Card.UniqueID}-${i}`} />
                                            <label className="card-outer" htmlFor={`${Settings.Card.UniqueID}-${i}`} style={{
                                                borderStyle: Settings.Border.BorderStyle,
                                                borderColor: Settings.Border.BorderColor,
                                                borderWidth: `${Settings.Border.BorderWidth}px`,
                                                borderRadius: `${Settings.Border.BorderRadius}px`,
                                                backgroundColor: Settings.Card.BackgroundColor,
                                                paddingTop: `${Settings.Card.Padding.top}px`,
                                                paddingRight: `${Settings.Card.Padding.right}px`,
                                                paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                                paddingLeft: `${Settings.Card.Padding.left}px`,
                                                textAlign: Settings.Text.Align
                                            }}>

                                                <div className="card-inner">
                                                    {list.Image ? <div class="icon-wrapper">
                                                        <img src={resolveMediaUrl(list.Image)} alt="" height={Settings.Card.IconSize} width={Settings.Card.IconSize} />
                                                    </div> : ""}
                                                    <div className="text-wrapper">
                                                        <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>
                                                        <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>

                                                    </div>
                                                    <div className="button-wrapper">
                                                        <button className='btn btn-action'>
                                                            <Svg name="roi-card-button" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },

    },
};

export default function CustomComponents() {
    return (
        <>
            <Render config={config} data={WhiteCardData} />
        </>
    )
}
